{
  "translation": {
    "allocations": {
      "actions": {
        "assign": "Asignar"
      },
      "errors": {
        "deleting": "",
        "saving": "",
        "validation": ""
      },
      "fields": {
        "employee": "Asignado a"
      },
      "successes": {
        "deleted": "",
        "save": ""
      }
    },
    "appointments": {
      "actions": {
        "block": "",
        "calculate": "",
        "cancel": "Cancelar",
        "intake": "Consumo",
        "new": "Nueva cita",
        "preview": "",
        "reschedule": "Reprogramar",
        "sendreminder": "",
        "unblock": "",
        "viewjob": "Ver trabajo"
      },
      "errors": {
        "blocking": "",
        "canceling": "Error al cancelar la cita. {{message}}",
        "saving": "Error al programar la cita. {{message}}"
      },
      "fields": {
        "alt_transport": "",
        "color": "",
        "end": "",
        "note": "",
        "start": "",
        "time": "",
        "title": "Título"
      },
      "labels": {
        "arrivedon": "Llegado el:",
        "arrivingjobs": "",
        "blocked": "",
        "bp": "",
        "cancelledappointment": "Cita cancelada para:",
        "completingjobs": "",
        "dataconsistency": "",
        "expectedjobs": "",
        "expectedprodhrs": "",
        "history": "",
        "inproduction": "",
        "manualevent": "",
        "noarrivingjobs": "",
        "nocompletingjobs": "",
        "nodateselected": "No se ha seleccionado ninguna fecha.",
        "owner": "",
        "priorappointments": "Nombramientos previos",
        "reminder": "",
        "ro_number": "",
        "scheduled_completion": "",
        "scheduledfor": "Cita programada para:",
        "severalerrorsfound": "",
        "smartscheduling": "",
        "smspaymentreminder": "",
        "suggesteddates": "",
        "vehicle": ""
      },
      "successes": {
        "canceled": "Cita cancelada con éxito.",
        "created": "Cita programada con éxito.",
        "saved": ""
      }
    },
    "associations": {
      "actions": {
        "activate": "Activar"
      },
      "fields": {
        "active": "¿Activo?",
        "shopname": "Nombre de tienda"
      },
      "labels": {
        "actions": "Comportamiento"
      }
    },
    "audio": {
      "manager": {
        "description": ""
      }
    },
    "audit": {
      "fields": {
        "cc": "",
        "contents": "",
        "created": "",
        "operation": "",
        "status": "",
        "subject": "",
        "to": "",
        "useremail": "",
        "values": ""
      }
    },
    "audit_trail": {
      "messages": {
        "admin_job_remove_from_ar": "",
        "admin_jobmarkexported": "",
        "admin_jobmarkforreexport": "",
        "admin_jobuninvoice": "",
        "admin_jobunvoid": "",
        "alerttoggle": "",
        "appointmentcancel": "",
        "appointmentinsert": "",
        "assignedlinehours": "",
        "billdeleted": "",
        "billmarkforreexport": "",
        "billposted": "",
        "billupdated": "",
        "failedpayment": "",
        "jobassignmentchange": "",
        "jobassignmentremoved": "",
        "jobchecklist": "",
        "jobclosedwithbypass": "",
        "jobconverted": "",
        "jobdelivery": "",
        "jobexported": "",
        "jobfieldchanged": "",
        "jobimported": "",
        "jobinproductionchange": "",
        "jobintake": "",
        "jobinvoiced": "",
        "jobioucreated": "",
        "joblineupdate": "",
        "jobmanualcreate": "",
        "jobmanuallineinsert": "",
        "jobmodifylbradj": "",
        "jobnoteadded": "",
        "jobnotedeleted": "",
        "jobnoteupdated": "",
        "jobspartsorder": "",
        "jobspartsreturn": "",
        "jobstatuschange": "",
        "jobsupplement": "",
        "jobsuspend": "",
        "jobvoid": "",
        "paymententered": "",
        "paymentupdated": "",
        "tasks_completed": "",
        "tasks_created": "",
        "tasks_deleted": "",
        "tasks_uncompleted": "",
        "tasks_undeleted": "",
        "tasks_updated": "",
        "techjobstatuschange": "",
        "timeticketcreated": "",
        "timeticketpayall": "",
        "timeticketupdated": ""
      }
    },
    "billlines": {
      "actions": {
        "newline": ""
      },
      "fields": {
        "actual_cost": "",
        "actual_price": "",
        "confidence": "",
        "cost_center": "",
        "federal_tax_applicable": "",
        "jobline": "",
        "line_desc": "",
        "local_tax_applicable": "",
        "location": "",
        "oem_partno": "",
        "quantity": "",
        "state_tax_applicable": ""
      },
      "labels": {
        "deductedfromlbr": "",
        "entered": "",
        "from": "",
        "mod_lbr_adjustment": "",
        "other": "",
        "reconciled": "",
        "unreconciled": ""
      },
      "validation": {
        "atleastone": ""
      }
    },
    "bills": {
      "actions": {
        "deductallhours": "",
        "edit": "",
        "receive": "",
        "return": ""
      },
      "errors": {
        "calculating_totals": "",
        "calculating_totals_generic": "",
        "creating": "",
        "deleting": "",
        "existinginventoryline": "",
        "exporting": "",
        "exporting-partner": "",
        "invalidro": "",
        "invalidvendor": "",
        "validation": ""
      },
      "fields": {
        "allpartslocation": "",
        "date": "",
        "exported": "",
        "federal_tax_rate": "",
        "invoice_number": "",
        "is_credit_memo": "",
        "is_credit_memo_short": "",
        "local_tax_rate": "",
        "ro_number": "",
        "state_tax_rate": "",
        "total": "",
        "vendor": "",
        "vendorname": ""
      },
      "labels": {
        "actions": "",
        "ai": {
          "accept_and_continue": "",
          "confidence": {
            "breakdown": "",
            "match": "",
            "missing_data": "",
            "ocr": "",
            "overall": ""
          },
          "disclaimer_title": "",
          "feedback_placeholder": "",
          "feedback_prompt": "",
          "generic_failure": "",
          "multipage": "",
          "processing": "",
          "scan": "",
          "scancomplete": "",
          "scanfailed": "",
          "scanstarted": "",
          "submit_feedback": ""
        },
        "bill_lines": "",
        "bill_total": "",
        "billcmtotal": "",
        "bills": "",
        "calculatedcreditsnotreceived": "",
        "creditsnotreceived": "",
        "creditsreceived": "",
        "dedfromlbr": "",
        "deleteconfirm": "",
        "discrepancy": "",
        "discrepwithcms": "",
        "discrepwithlbradj": "",
        "editadjwarning": "",
        "entered_total": "",
        "enteringcreditmemo": "",
        "federal_tax": "",
        "federal_tax_exempt": "",
        "generatepartslabel": "",
        "iouexists": "",
        "local_tax": "",
        "markexported": "",
        "markforreexport": "",
        "new": "",
        "nobilllines": "",
        "noneselected": "",
        "onlycmforinvoiced": "",
        "printlabels": "",
        "retailtotal": "",
        "returnfrombill": "",
        "savewithdiscrepancy": "",
        "state_tax": "",
        "subtotal": "",
        "totalreturns": ""
      },
      "successes": {
        "created": "",
        "deleted": "",
        "exported": "",
        "markexported": "",
        "reexport": ""
      },
      "validation": {
        "closingperiod": "",
        "inventoryquantity": "",
        "manualinhouse": "",
        "unique_invoice_number": ""
      }
    },
    "bodyshop": {
      "actions": {
        "add_adjuster": "",
        "add_control_number": "",
        "add_cost_center": "",
        "add_courtesy_car_rate_preset": "",
        "add_delivery_checklist_item": "",
        "add_dms_allocation": "",
        "add_estimator": "",
        "add_insurance_company": "",
        "add_intake_checklist_item": "",
        "add_jobline_preset": "",
        "add_messaging_preset": "",
        "add_note_preset": "",
        "add_parts_order_comment": "",
        "add_production_status_color": "",
        "add_profit_center": "",
        "add_task_preset": "",
        "add_to_email_preset": "",
        "addapptcolor": "",
        "addbucket": "",
        "addpartslocation": "",
        "addpartsrule": "",
        "addspeedprint": "",
        "addtemplate": "",
        "newlaborrate": "",
        "newsalestaxcode": "",
        "newstatus": "",
        "save_shop_information": "",
        "testrender": ""
      },
      "errors": {
        "creatingdefaultview": "",
        "duplicate_insurance_company": "",
        "duplicate_job_status": "",
        "loading": "No se pueden cargar los detalles de la tienda. Por favor llame al soporte técnico.",
        "media_tag_in_use": "La etiqueta '{{tag}}' está asignada a uno o más archivos y no se puede eliminar.",
        "media_tag_reserved": "'{{tag}}' está reservada para el almacenamiento multimedia y no se puede usar como etiqueta. Nombres reservados: {{reservedTags}}.",
        "media_tag_usage_loading": "Todavía se está comprobando el uso de etiquetas. Espere a que termine la comprobación antes de eliminar una etiqueta existente.",
        "media_tag_usage_unavailable": "No se pudo comprobar el uso de etiquetas. Las etiquetas existentes no se pueden eliminar hasta que el proveedor multimedia esté disponible.",
        "saving": "",
        "task_preset_allocation_exceeded": ""
      },
      "fields": {
        "ReceivableCustomField": "",
        "accumulatePayableLines": "",
        "address1": "",
        "address2": "",
        "appt_alt_transport": "",
        "appt_colors": {
          "color": "",
          "label": ""
        },
        "appt_length": "",
        "attach_pdf_to_email": "",
        "batchid": "",
        "bill_allow_post_to_closed": "",
        "bill_federal_tax_rate": "",
        "bill_local_tax_rate": "",
        "bill_state_tax_rate": "",
        "city": "",
        "closingperiod": "",
        "companycode": "",
        "country": "",
        "dailybodytarget": "",
        "dailypainttarget": "",
        "default": "",
        "default_adjustment_rate": "",
        "deliver": {
          "require_actual_delivery_date": "",
          "templates": ""
        },
        "disableBillCostCalculation": "",
        "dms": {
          "apcontrol": "",
          "appostingaccount": "",
          "cashierid": "",
          "default_journal": "",
          "disablebillwip": "",
          "disablecontact": "",
          "disablecontactvehiclecreation": "",
          "dms_acctnumber": "",
          "dms_control_override": "",
          "dms_wip_acctnumber": "",
          "generic_customer_number": "",
          "itc_federal": "",
          "itc_local": "",
          "itc_state": "",
          "mappingname": "",
          "ro_posting": "",
          "sendmaterialscosting": "",
          "srcco": ""
        },
        "email": "",
        "enforce_class": "",
        "enforce_conversion_category": "",
        "enforce_conversion_csr": "",
        "enforce_referral": "",
        "enforce_registration_number": "¿Aplicar número de matrícula en la conversión?",
        "federal_tax_id": "",
        "ignoreblockeddays": "",
        "inhousevendorid": "",
        "insurance_vendor_id": "",
        "intake": {
          "next_contact_hours": "",
          "templates": ""
        },
        "intellipay_config": {
          "cash_discount_percentage": "",
          "enable_cash_discount": "",
          "payment_map": {
            "amex": "American Express",
            "disc": "Discover",
            "dnrs": "Diners",
            "intr": "Interac",
            "jcb": "JCB",
            "mast": "MasterCard",
            "visa": "Visa"
          },
          "payment_type": ""
        },
        "invoice_federal_tax_rate": "",
        "invoice_local_tax_rate": "",
        "invoice_state_tax_rate": "",
        "jc_hourly_rates": {
          "mapa": "",
          "mash": ""
        },
        "last_name_first": "",
        "lastnumberworkingdays": "",
        "localmediaserverhttp": "",
        "localmediaservernetwork": "",
        "localmediatoken": "",
        "logo_img_footer_margin": "",
        "logo_img_header_margin": "",
        "logo_img_path": "",
        "logo_img_path_height": "",
        "logo_img_path_width": "",
        "md_categories": "",
        "md_ccc_rates": "",
        "md_classes": "",
        "md_ded_notes": "",
        "md_email_cc": "",
        "md_from_emails": "",
        "md_functionality_toggles": {
          "enhanced_early_ros": "",
          "parts_queue_toggle": ""
        },
        "md_hour_split": {
          "paint": "",
          "prep": ""
        },
        "md_ins_co": {
          "city": "",
          "name": "",
          "private": "",
          "state": "",
          "street1": "",
          "street2": "",
          "zip": ""
        },
        "md_jobline_presets": "",
        "md_lost_sale_reasons": "",
        "md_parts_order_comment": "",
        "md_parts_scan": {
          "caseInsensitive": "",
          "expression": "",
          "field": "",
          "flags": "",
          "mark_critical": "",
          "operation": "",
          "update_field": "",
          "update_value": "",
          "value": ""
        },
        "md_payment_types": "",
        "md_referral_sources": "",
        "md_ro_guard": {
          "enabled": "",
          "enforce_ar": "",
          "enforce_bills": "",
          "enforce_cm": "",
          "enforce_labor": "",
          "enforce_ppd": "",
          "enforce_profit": "",
          "enforce_sublet": "",
          "masterbypass": "",
          "totalgppercent_minimum": ""
        },
        "md_tasks_presets": {
          "enable_tasks": "",
          "hourstype": "",
          "memo": "",
          "name": "",
          "nextstatus": "",
          "percent": "",
          "use_approvals": ""
        },
        "messaginglabel": "",
        "messaginglabel_short": "",
        "messagingtext": "",
        "messagingtext_short": "",
        "noteslabel": "",
        "noteslabel_short": "",
        "notestext": "",
        "notestext_short": "",
        "notifications": {
          "description": "",
          "invalid_followers": "",
          "placeholder": ""
        },
        "partslocation": "",
        "phone": "",
        "prodtargethrs": "",
        "rbac": {
          "accounting": {
            "exportlog": "",
            "payables": "",
            "payments": "",
            "receivables": ""
          },
          "bills": {
            "delete": "",
            "enter": "",
            "list": "",
            "reexport": "",
            "view": ""
          },
          "contracts": {
            "create": "",
            "detail": "",
            "list": ""
          },
          "courtesycar": {
            "create": "",
            "detail": "",
            "list": ""
          },
          "csi": {
            "export": "",
            "page": ""
          },
          "employee_teams": {
            "page": ""
          },
          "employees": {
            "page": ""
          },
          "inventory": {
            "delete": "",
            "list": ""
          },
          "jobs": {
            "admin": "",
            "available-list": "",
            "checklist-view": "",
            "close": "",
            "create": "",
            "deliver": "",
            "detail": "",
            "intake": "",
            "list-active": "",
            "list-all": "",
            "list-ready": "",
            "manual-line": "",
            "partsqueue": "",
            "void": ""
          },
          "owners": {
            "detail": "",
            "list": ""
          },
          "payments": {
            "enter": "",
            "list": ""
          },
          "phonebook": {
            "edit": "",
            "view": ""
          },
          "production": {
            "board": "",
            "list": ""
          },
          "schedule": {
            "view": ""
          },
          "scoreboard": {
            "view": ""
          },
          "shiftclock": {
            "view": ""
          },
          "shop": {
            "config": "",
            "dashboard": "",
            "jobStatus": "",
            "rbac": "",
            "reportcenter": "",
            "responsibilitycenter": "",
            "templates": "",
            "vendors": ""
          },
          "temporarydocs": {
            "view": ""
          },
          "timetickets": {
            "edit": "",
            "editcommitted": "",
            "enter": "",
            "list": "",
            "shiftedit": ""
          },
          "ttapprovals": {
            "approve": "",
            "view": ""
          },
          "users": {
            "editaccess": ""
          }
        },
        "responsibilitycenter": "",
        "responsibilitycenter_accountdesc": "",
        "responsibilitycenter_accountitem": "",
        "responsibilitycenter_accountname": "",
        "responsibilitycenter_accountnumber": "",
        "responsibilitycenter_rate": "",
        "responsibilitycenter_tax_rate": "",
        "responsibilitycenter_tax_sur": "",
        "responsibilitycenter_tax_thres": "",
        "responsibilitycenter_tax_tier": "",
        "responsibilitycenter_tax_type": "",
        "responsibilitycenters": {
          "ap": "",
          "ar": "",
          "ats": "",
          "federal_tax": "",
          "federal_tax_itc": "",
          "gogcode": "",
          "gst_override": "",
          "invoice_federal_tax_rate_short": "",
          "invoice_local_tax_rate_short": "",
          "invoice_state_tax_rate_short": "",
          "invoiceexemptcode": "",
          "invoiceexemptcode_short": "",
          "item_type": "Item Type",
          "item_type_freight": "",
          "item_type_gog": "",
          "item_type_misc": "",
          "item_type_paint": "",
          "itemexemptcode": "",
          "itemexemptcode_short": "",
          "la1": "",
          "la2": "",
          "la3": "",
          "la4": "",
          "laa": "",
          "lab": "",
          "lad": "",
          "lae": "",
          "laf": "",
          "lag": "",
          "lam": "",
          "lar": "",
          "las": "",
          "lau": "",
          "local_tax": "",
          "mapa": "",
          "mash": "",
          "nontaxable": "",
          "paa": "",
          "pac": "",
          "pag": "",
          "pal": "",
          "pam": "",
          "pan": "",
          "pao": "",
          "pap": "",
          "par": "",
          "pas": "",
          "pasl": "",
          "refund": "",
          "sales_tax_codes": {
            "code": "",
            "description": "",
            "federal": "",
            "local": "",
            "state": ""
          },
          "state_tax": "",
          "taxable": "",
          "taxable_flag": "",
          "tow": ""
        },
        "schedule_end_time": "",
        "schedule_start_time": "",
        "scoreboard_setup": {
          "daily_body_target": "",
          "daily_paint_target": "",
          "ignore_blocked_days": "",
          "last_number_working_days": "",
          "production_target_hours": ""
        },
        "shopname": "",
        "speedprint": {
          "id": "",
          "label": "",
          "templates": ""
        },
        "ss_configuration": {
          "dailyhrslimit": "",
          "nobusinessdays": ""
        },
        "ssbuckets": {
          "color": "",
          "gte": "",
          "id": "",
          "label": "",
          "lt": "",
          "target": ""
        },
        "state": "",
        "state_tax_id": "",
        "status": "",
        "statuses": {
          "active_statuses": "",
          "additional_board_statuses": "",
          "color": "",
          "default_arrived": "",
          "default_bo": "",
          "default_canceled": "",
          "default_completed": "",
          "default_delivered": "",
          "default_exported": "",
          "default_imported": "",
          "default_invoiced": "",
          "default_ordered": "",
          "default_quote": "",
          "default_received": "",
          "default_returned": "",
          "default_scheduled": "",
          "default_void": "",
          "open_statuses": "",
          "post_production_statuses": "",
          "pre_production_statuses": "",
          "production_colors": "",
          "production_statuses": "",
          "ready_statuses": ""
        },
        "system_settings": {
          "auto_email": {
            "attach_pdf_to_email": "",
            "from_emails": "",
            "parts_order_cc": "",
            "parts_return_slip_cc": ""
          },
          "job_costing": {
            "paint_hour_split": "",
            "paint_materials_hourly_cost_rate": "",
            "prep_hour_split": "",
            "shop_materials_hourly_cost_rate": "",
            "target_touch_time": "",
            "use_paint_scale_data": ""
          },
          "local_media_server": {
            "enabled": "",
            "http_path": "",
            "network_path": "",
            "token": ""
          },
          "media_tags": "Etiquetas disponibles",
          "media_tags_help": "Estas etiquetas se pueden asignar a archivos desde la galería del trabajo. No se pueden usar los nombres de carpetas del sistema bills, thumbs y ConvertedOriginal. Las etiquetas asignadas a archivos no se pueden eliminar."
        },
        "target_touchtime": "",
        "timezone": "",
        "tt_allow_post_to_invoiced": "",
        "tt_enforce_hours_for_tech_console": "",
        "tech_console": {
          "inactivity_timeout_enabled": "Activar el tiempo de espera por inactividad",
          "inactivity_timeout_enabled_help": "Cuando está activado, los técnicos inactivos cerrarán sesión automáticamente en la consola técnica.",
          "inactivity_timeout_help": "El técnico cerrará sesión después de esta cantidad de minutos sin actividad del teclado, puntero, pantalla táctil, rueda o desplazamiento. Ingrese un valor entre {{min}} y {{max}} minutos.",
          "inactivity_timeout_minutes": "Tiempo de espera por inactividad",
          "inactivity_timeout_validation": "Ingrese un número entero entre {{min}} y {{max}} minutos.",
          "minutes": "minutos"
        },
        "use_fippa": "",
        "use_paint_scale_data": "",
        "uselocalmediaserver": "",
        "website": "",
        "zip_post": ""
      },
      "labels": {
        "2tiername": "",
        "2tiersetup": "",
        "2tiersource": "",
        "accountingsetup": "",
        "accountingtiers": "",
        "alljobstatuses": "",
        "allopenjobstatuses": "",
        "apptcolors": "",
        "autoemail": "",
        "businessinformation": "",
        "checklists": "",
        "consent_settings": "",
        "csiq": "",
        "customtemplates": "",
        "defaultcostsmapping": "",
        "defaultprofitsmapping": "",
        "deliverchecklist": "",
        "dms": {
          "cdk": {
            "controllist": "",
            "payers": ""
          },
          "cdk_dealerid": "",
          "costsmapping": "",
          "dms_allocations": "",
          "pbs_serialnumber": "",
          "profitsmapping": "",
          "rr_dealerid": "",
          "title": ""
        },
        "dms_setup": "",
        "emaillater": "",
        "employee_options": "",
        "employee_rates": "",
        "employee_teams": "",
        "employee_vacation": "",
        "employees": "",
        "estimators": "",
        "filehandlers": "",
        "imexpay": "",
        "insurancecos": "",
        "intake_delivery": "",
        "intakechecklist": "",
        "intellipay_cash_discount": "",
        "job_status_options": "",
        "jobcosting": "",
        "jobstatuses": "",
        "jump_to_section": "",
        "laborrates": "",
        "licensing": "",
        "localmediaserver": "",
        "media_tag_in_use": "Esta etiqueta está en uso y no se puede eliminar.",
        "media_tags": "Etiquetas de imágenes y documentos",
        "md_parts_scan": "",
        "md_ro_guard": "",
        "md_ro_guard_options": "",
        "md_tasks_presets": "",
        "md_to_emails": "",
        "md_to_emails_emails": "",
        "messagingpresets": "",
        "notemplatesavailable": "",
        "notespresets": "",
        "notification_options": "",
        "notifications": {
          "followers": ""
        },
        "orderstatuses": "",
        "parts_shop_management": "",
        "parts_vendor_management": "",
        "partslocations": "",
        "partsscan": "",
        "printlater": "",
        "qbo": "",
        "qbo_departmentid": "",
        "qbo_usa": "",
        "rbac": "",
        "rbac_options": "",
        "tech_console": "Consola técnica",
        "tech_console_options": "Opciones de la consola técnica",
        "responsibilitycenters": {
          "costs": "",
          "default_tax_setup": "",
          "invoices": "",
          "profits": "",
          "quickbooks_qbd": "",
          "quickbooks_us": "",
          "sales_tax_codes": "",
          "tax_accounts": "",
          "tax_rate_short": "",
          "tax_surcharge_short": "",
          "tax_threshold_short": "",
          "tax_tier_card": "",
          "tax_tier_short": "",
          "tax_type_card": "",
          "title": "",
          "ttl_adjustment": "",
          "ttl_tax_adjustment": ""
        },
        "roguard": {
          "title": ""
        },
        "romepay": "",
        "scheduling": "",
        "scoreboardsetup": "",
        "shop_enabled_features": "",
        "shopinfo": "",
        "shoprates": "",
        "speedprint": "",
        "speedprint_configurations": "",
        "ssbuckets": "",
        "systemsettings": "",
        "task-presets": "",
        "task_preset_options": "",
        "workingdays": ""
      },
      "operations": {
        "contains": "",
        "ends_with": "",
        "equals": "",
        "greater_than": "",
        "less_than": "",
        "not_equals": "",
        "starts_with": ""
      },
      "successes": {
        "areyousure": "",
        "defaultviewcreated": "",
        "save": "",
        "unsavedchanges": ""
      },
      "tooltips": {
        "md_parts_scan": {
          "update_value_tooltip": ""
        },
        "reset-color": ""
      },
      "validation": {
        "centermustexist": "",
        "duplicatecentername": "Ya existe un centro de responsabilidad con este nombre.",
        "larsplit": "",
        "useremailmustexist": ""
      }
    },
    "checklist": {
      "actions": {
        "printall": ""
      },
      "errors": {
        "complete": "",
        "nochecklist": ""
      },
      "labels": {
        "addtoproduction": "",
        "checklist": "",
        "printpack": "",
        "removefromproduction": ""
      },
      "successes": {
        "completed": ""
      }
    },
    "commandpalette": {
      "hints": {
        "close": "cerrar",
        "navigate": "navegar",
        "select": "abrir"
      },
      "noresults": "No hay resultados para \"{{search}}\"",
      "placeholder": "Buscar órdenes, clientes, vehículos o escribir un comando...",
      "sections": {
        "actions": "Acciones rápidas",
        "pages": "Ir a la página",
        "recent": "Recientes"
      },
      "tooltip": "Búsqueda y comandos (Ctrl+K)"
    },
    "consent": {
      "associated_owners": "",
      "created_at": "",
      "no_owners": "",
      "phone_1": "",
      "phone_2": "",
      "phone_number": "",
      "text_body": ""
    },
    "contracts": {
      "actions": {
        "changerate": "",
        "convertoro": "",
        "decodelicense": "",
        "find": "",
        "printcontract": "",
        "senddltoform": ""
      },
      "errors": {
        "fetchingjobinfo": "",
        "returning": "",
        "saving": "",
        "selectjobandcar": ""
      },
      "fields": {
        "actax": "",
        "actualreturn": "",
        "agreementnumber": "",
        "cc_cardholder": "",
        "cc_expiry": "",
        "cc_num": "",
        "cleanupcharge": "",
        "coverage": "",
        "dailyfreekm": "",
        "dailyrate": "",
        "damage": "",
        "damagewaiver": "",
        "driver": "",
        "driver_addr1": "",
        "driver_addr2": "",
        "driver_city": "",
        "driver_dlexpiry": "",
        "driver_dlnumber": "",
        "driver_dlst": "",
        "driver_dob": "",
        "driver_fn": "",
        "driver_ln": "",
        "driver_ph1": "",
        "driver_state": "",
        "driver_zip": "",
        "excesskmrate": "",
        "federaltax": "",
        "fuelin": "",
        "fuelout": "",
        "kmend": "",
        "kmstart": "",
        "length": "",
        "localtax": "",
        "refuelcharge": "",
        "scheduledreturn": "",
        "start": " ",
        "statetax": "",
        "status": ""
      },
      "labels": {
        "agreement": "",
        "availablecars": "",
        "cardueforservice": "",
        "convertform": {
          "applycleanupcharge": "",
          "refuelqty": ""
        },
        "correctdataonform": "",
        "dateinpast": "",
        "dlexpirebeforereturn": "",
        "driverinformation": "",
        "findcontract": "",
        "findermodal": "",
        "insuranceexpired": "",
        "noteconvertedfrom": "",
        "populatefromjob": "",
        "rates": "",
        "time": "",
        "vehicle": "",
        "waitingforscan": ""
      },
      "status": {
        "new": "",
        "out": "",
        "returned": ""
      },
      "successes": {
        "saved": ""
      }
    },
    "courtesycars": {
      "actions": {
        "new": "",
        "return": ""
      },
      "errors": {
        "saving": ""
      },
      "fields": {
        "color": "",
        "dailycost": "",
        "damage": "",
        "fleetnumber": "",
        "fuel": "",
        "insuranceexpires": "",
        "leaseenddate": "",
        "make": "",
        "mileage": "",
        "model": "",
        "nextservicedate": "",
        "nextservicekm": "",
        "notes": "",
        "plate": "",
        "purchasedate": "",
        "readiness": "",
        "registrationexpires": "",
        "serviceenddate": "",
        "servicestartdate": "",
        "status": "",
        "vin": "",
        "year": ""
      },
      "labels": {
        "courtesycar": "",
        "fuel": {
          "12": "",
          "14": "",
          "18": "",
          "34": "",
          "38": "",
          "58": "",
          "78": "",
          "empty": "",
          "full": ""
        },
        "outwith": "",
        "return": "",
        "status": "",
        "uniquefleet": "",
        "usage": "",
        "vehicle": ""
      },
      "readiness": {
        "notready": "",
        "ready": ""
      },
      "status": {
        "in": "",
        "inservice": "",
        "leasereturn": "",
        "out": "",
        "sold": "",
        "unavailable": ""
      },
      "successes": {
        "saved": ""
      }
    },
    "csi": {
      "actions": {
        "activate": ""
      },
      "errors": {
        "creating": "",
        "notconfigured": "",
        "notfoundsubtitle": "",
        "notfoundtitle": "",
        "surveycompletesubtitle": "",
        "surveycompletetitle": ""
      },
      "fields": {
        "completedon": "",
        "created_at": "",
        "surveyid": "",
        "validuntil": ""
      },
      "labels": {
        "copyright": "",
        "greeting": "",
        "intro": "",
        "nologgedinuser": "",
        "nologgedinuser_sub": "",
        "noneselected": "",
        "title": ""
      },
      "successes": {
        "created": "",
        "submitted": "",
        "submittedsub": ""
      }
    },
    "dashboard": {
      "actions": {
        "addcomponent": ""
      },
      "errors": {
        "atp": "",
        "insco": "",
        "refreshrequired": "",
        "status": "",
        "status_normal": "",
        "updatinglayout": ""
      },
      "labels": {
        "asoftoday": "",
        "attarget": "",
        "belowtarget": "",
        "bodyhrs": "",
        "dollarsinproduction": "",
        "duein": "",
        "efficiencychart": "",
        "emptydeliverytoday": "",
        "emptyhint": "",
        "emptyintoday": "",
        "emptyouttoday": "",
        "emptyproductionstatus": "",
        "hourschart": "",
        "jobs": "",
        "jobscount": "",
        "newperiod": "",
        "overdue": "",
        "overdueby": "",
        "overduecount": "",
        "phone": "",
        "prodhrs": "",
        "prodhrsvstarget": "",
        "refhrs": "",
        "status": "",
        "subtotal": "",
        "tableview": "",
        "targethrs": "",
        "todaycount": "",
        "total": "",
        "tvview": "",
        "vslastmonth": "",
        "vslastyear": "",
        "unknownstatus": ""
      },
      "titles": {
        "joblifecycle": "",
        "labhours": "",
        "larhours": "",
        "monthlyemployeeefficiency": "",
        "monthlyjobcosting": "",
        "monthlylaborsales": "",
        "monthlypartssales": "",
        "monthlyrevenuegraph": "",
        "prodhrssummary": "",
        "productiondollars": "",
        "productionhours": "",
        "productionstatussummary": "",
        "projectedmonthlysales": "",
        "scheduleddeliverydate": "",
        "scheduleddeliverytoday": "",
        "scheduledindate": "",
        "scheduledintoday": "",
        "scheduledoutdate": "",
        "scheduledouttoday": "",
        "tasks": "",
        "yeartodatesales": ""
      }
    },
    "dms": {
      "errors": {
        "alreadyexported": "",
        "earlyrorequired": "",
        "earlyrorequired.message": ""
      },
      "labels": {
        "banner_message": "",
        "banner_status_connected": "",
        "banner_status_disconnected": "",
        "clear_logs": "",
        "collapse_all": "",
        "color_json": "",
        "copied": "",
        "copy": "",
        "copy_request": "",
        "copy_response": "",
        "details": "",
        "expand_all": "",
        "hide_details": "",
        "log_level": "",
        "plain_json": "",
        "provider_cdk": "",
        "provider_dms": "",
        "provider_fortellis": "",
        "provider_pbs": "",
        "provider_reynolds": "",
        "reconnect": "",
        "reconnected_export_service": "",
        "refreshallocations": "",
        "request_xml": "",
        "response_xml": "",
        "rr_validation_message": "",
        "rr_validation_notice_description": "",
        "rr_validation_notice_title": "",
        "transport_ws": "",
        "transport_wss": ""
      },
      "rr_allocations_preview": {
        "columns": {
          "amt_type": "",
          "bill_rate": "",
          "bill_time": "",
          "break_out": "",
          "code_amt": "",
          "cust_pay_type": "",
          "cust_price": "",
          "cust_qty": "",
          "cust_txbl_flag": "",
          "dlr_cost": "",
          "item_desc": "",
          "item_type": "",
          "job_no": "",
          "job_total_hrs": "",
          "misc_code": "",
          "op_code": "",
          "pay_type": "",
          "total_amt": ""
        },
        "descriptions": {
          "gog": "",
          "labor": "",
          "misc": ""
        },
        "empty": {
          "gog": "",
          "labor": "",
          "misc": ""
        },
        "labels": {
          "op_code": ""
        },
        "segments": {
          "extras_non_taxable": "",
          "extras_taxable": "",
          "labor_non_taxable": "",
          "labor_taxable": "",
          "parts_non_taxable": "",
          "parts_taxable": ""
        },
        "tabs": {
          "gog": "",
          "labor": "",
          "misc": ""
        }
      }
    },
    "documents": {
      "actions": {
        "delete": "Eliminar archivos seleccionados",
        "download": "Descargar archivos seleccionados",
        "reassign": "",
        "selectfiles": "Seleccionar archivos",
        "selectallimages": "Seleccionar todas las imágenes",
        "selectallotherdocuments": "Seleccionar todos los documentos",
        "applytag": "Aplicar etiquetas"
      },
      "errors": {
        "deletes3": "Error al eliminar el documento del almacenamiento.",
        "deleting": "",
        "deleting_cloudinary": "",
        "getpresignurl": "Error al obtener la URL prescrita para el documento. {{message}}",
        "insert": "Incapaz de cargar el archivo. {{message}}",
        "lms_mobile_browser": "Las imágenes del servidor multimedia local no están disponibles en un navegador móvil. Use la aplicación móvil para verlas o adjuntarlas.",
        "lms_unavailable": "No se pueden cargar las imágenes del servidor multimedia local. Compruebe su conexión a la red del taller e inténtelo de nuevo.",
        "nodocuments": "No hay documentos",
        "updating": ""
      },
      "labels": {
        "confirmdelete": "¿Está seguro de que desea eliminar estos archivos? Esta acción no se puede deshacer.",
        "alltags": "Todas las etiquetas",
        "doctype": "",
        "dragtoupload": "",
        "fileactions": "Acceso a archivos",
        "greyscale": "Escala de grises",
        "filtertag": "Filtrar por etiqueta",
        "lightboxtag": "Etiqueta: {{tag}}",
        "newjobid": "",
        "openinexplorer": "",
        "optimizedimage": "",
        "reassign_limitexceeded": "",
        "reassign_limitexceeded_title": "",
        "storageexceeded": "",
        "storageexceeded_title": "",
        "selecttag": "Seleccionar una etiqueta",
        "selectedactions": "Archivos seleccionados",
        "selectionactions": "Selección",
        "tagassignment": "Aplicar etiquetas",
        "tagfilter": "Filtrar por etiqueta",
        "untagged": "Sin etiqueta",
        "upload": "Subir",
        "upload_limitexceeded": "",
        "upload_limitexceeded_title": "",
        "uploading": "",
        "usage": ""
      },
      "successes": {
        "delete": "Documento eliminado con éxito.",
        "edituploaded": "El documento editado se cargó correctamente. Ahora puede cerrar esta ventana.",
        "insert": "Documento cargado con éxito.",
        "updated": ""
      }
    },
    "emails": {
      "errors": {
        "notsent": "Correo electrónico no enviado Se encontró un error al enviar {{message}}"
      },
      "fields": {
        "cc": "",
        "from": "",
        "subject": "",
        "to": ""
      },
      "labels": {
        "attachments": "",
        "documents": "",
        "emailpreview": "",
        "generatingemail": "",
        "pdfcopywillbeattached": "",
        "preview": ""
      },
      "successes": {
        "sent": "Correo electrónico enviado con éxito."
      }
    },
    "employee_teams": {
      "actions": {
        "new": "",
        "newmember": "",
        "save_team": ""
      },
      "errors": {
        "allocation_total_exact": "",
        "duplicate_member": "",
        "minimum_one_member": ""
      },
      "fields": {
        "active": "",
        "allocation": "",
        "allocation_percentage": "",
        "employeeid": "",
        "max_load": "",
        "name": "",
        "payout_method": "",
        "percentage": ""
      },
      "labels": {
        "allocation_total": "",
        "members": "",
        "team_options": ""
      },
      "options": {
        "commission": "",
        "commission_percentage": "",
        "hourly": ""
      }
    },
    "employees": {
      "actions": {
        "addrate": "",
        "addvacation": "",
        "new": "Nuevo empleado",
        "newrate": "",
        "save_employee": "",
        "select": ""
      },
      "errors": {
        "delete": "Se encontró un error al eliminar al empleado. {{message}}",
        "save": "Se encontró un error al salvar al empleado. {{message}}",
        "validation": "Por favor verifique todos los campos.",
        "validationtitle": "No se puede salvar al empleado."
      },
      "fields": {
        "active": "¿Activo?",
        "base_rate": "Tasa básica",
        "cost_center": "Centro de costos",
        "employee_number": "Numero de empleado",
        "external_id": "",
        "external_rate_code": "Código de tarifa externa",
        "first_name": "Nombre de pila",
        "flat_rate": "Tarifa plana (deshabilitado es tiempo recto)",
        "hire_date": "Fecha de contratación",
        "last_name": "Apellido",
        "pin": "",
        "rate": "",
        "termination_date": "Fecha de conclusión",
        "user_email": "",
        "vacation": {
          "end": "",
          "length": "",
          "start": ""
        }
      },
      "labels": {
        "actions": "",
        "active": "",
        "employee_number_short": "",
        "endmustbeafterstart": "",
        "flat_rate": "",
        "inactive": "",
        "name": "",
        "rate_type": "",
        "status": "",
        "straight_time": ""
      },
      "successes": {
        "delete": "Empleado eliminado con éxito.",
        "save": "Empleado guardado con éxito.",
        "vacationadded": ""
      },
      "validation": {
        "unique_employee_number": "",
        "unique_user_email": "Este correo electrónico ya está asignado a otro empleado."
      }
    },
    "esignature": {
      "actions": {
        "delete": "",
        "distribute": "",
        "redistribute": "",
        "upload_document": "Upload Document for E-Sign",
        "view": ""
      },
      "errors": {
        "no_token": "",
        "pdf_only": "Only PDF documents can be uploaded for e-signature.",
        "upload_title": "Unable to prepare document for e-signature"
      },
      "confirm": {
        "discard_title": "Descartar este documento?",
        "discard_content": "El documento cargado y los campos que haya colocado se eliminaran permanentemente del servidor de firmas.",
        "discard_ok": "Descartar",
        "discard_cancel": "Seguir editando"
      },
      "tooltips": {
        "contact_sales": "Las firmas electronicas no estan habilitadas para este taller. Contacte a ventas para agregar esta funcion.",
        "distribute_checking": "Verificando el estado del documento...",
        "distribute_incomplete": "Complete la configuracion del documento en el editor y haga clic en Guardar antes de distribuir.",
        "distribute_missing_fields": "Agregue un campo de firma para {{recipients}} en el editor y luego haga clic en Guardar para habilitar la distribucion."
      },
      "fields": {
        "completed": "",
        "completed_at": "",
        "created_at": "",
        "external_document_id": "",
        "opened": "",
        "rejected": "",
        "status": "",
        "title": "",
        "updated_at": ""
      }
    },
    "eula": {
      "buttons": {
        "accept": "Accept EULA"
      },
      "content": {
        "never_scrolled": "You must scroll to the bottom of the Terms and Conditions before accepting."
      },
      "errors": {
        "acceptance": {
          "description": "Something went wrong while accepting the EULA. Please try again.",
          "message": "Eula Acceptance Error"
        }
      },
      "labels": {
        "accepted_terms": "I accept the terms and conditions of this agreement.",
        "address": "Address",
        "business_name": "Legal Business Name",
        "date_accepted": "Date Accepted",
        "first_name": "First Name",
        "last_name": "Last Name",
        "phone_number": "Phone Number"
      },
      "messages": {
        "accepted_terms": "Please accept the terms and conditions of this agreement.",
        "business_name": "Please enter your legal business name.",
        "date_accepted": "Please enter Today's Date.",
        "first_name": "Please enter your first name.",
        "last_name": "Please enter your last name.",
        "phone_number": "Please enter your phone number."
      },
      "titles": {
        "modal": "Terms and Conditions",
        "upper_card": "Acknowledgement"
      }
    },
    "exportlogs": {
      "fields": {
        "createdat": ""
      },
      "labels": {
        "attempts": "",
        "priorsuccesfulexport": ""
      }
    },
    "general": {
      "actions": {
        "add": "",
        "addtoproduction": "",
        "autoupdate": "",
        "calculate": "",
        "cancel": "Cancelar",
        "clear": "",
        "connectquickbooks": "Connect to QuickBooks",
        "close": "Cerrar",
        "copied": "",
        "copylink": "",
        "create": "",
        "defaults": "Predeterminados",
        "delay": "",
        "delete": "Borrar",
        "deleteall": "",
        "deselectall": "Deseleccionar todo",
        "done": "",
        "download": "",
        "edit": "Editar",
        "fliphorizontal": "Voltear horizontalmente",
        "flipvertical": "Voltear verticalmente",
        "gotoadmin": "",
        "login": "",
        "next": "",
        "ok": "",
        "optional": "",
        "or": "or",
        "previous": "",
        "print": "",
        "refresh": "Actualizar",
        "remove": "",
        "remove_alert": "",
        "reset": " Restablecer a original.",
        "resetpassword": "",
        "rotateleft": "Girar a la izquierda",
        "rotateright": "Girar a la derecha",
        "save": "Salvar",
        "saveandnew": "",
        "saveas": "Guardar como",
        "select": "",
        "selectall": "Seleccionar todo",
        "send": "",
        "sendbysms": "",
        "senderrortosupport": "",
        "sharetoteams": "",
        "submit": "",
        "tryagain": "",
        "view": "",
        "viewreleasenotes": "",
        "zoomin": "Acercar",
        "zoomout": "Alejar"
      },
      "errors": {
        "fcm": "",
        "notfound": "",
        "sizelimit": "",
        "sub_status": {
          "expired": "",
          "trial-expired": "",
          "undefined": ""
        },
        "submit-for-testing": ""
      },
      "itemtypes": {
        "contract": "",
        "courtesycar": "",
        "job": "",
        "owner": "",
        "vehicle": ""
      },
      "labels": {
        "actions": "Comportamiento",
        "apply": "",
        "areyousure": "",
        "barcode": "código de barras",
        "beta": "",
        "cancel": "",
        "changelog": "",
        "clear": "",
        "click_to_begin": "",
        "confirmpassword": "",
        "created_at": "",
        "date": "",
        "datetime": "",
        "email": "",
        "errors": "",
        "excel": "",
        "exceptiontitle": "",
        "feature-request": "",
        "friday": "",
        "globalsearch": "",
        "help": "",
        "hours": "",
        "in": "en",
        "instanceconflictext": "",
        "instanceconflictitle": "",
        "item": "",
        "label": "",
        "loading": "Cargando...",
        "loadingapp": "Cargando {{app}}",
        "loadingshop": "Cargando datos de la tienda ...",
        "loggingin": "Iniciando sesión ...",
        "markedexported": "",
        "media": "",
        "message": "",
        "monday": "",
        "na": "N / A",
        "newpassword": "",
        "no": "",
        "nointernet": "",
        "nointernet_sub": "",
        "none": "",
        "out": "Afuera",
        "password": "",
        "passwordresetsuccess": "",
        "passwordresetsuccess_sub": "",
        "passwordresetvalidatesuccess": "",
        "passwordresetvalidatesuccess_sub": "",
        "passwordsdonotmatch": "",
        "print": "",
        "refresh": "",
        "reports": "",
        "required": "",
        "saturday": "",
        "search": "Buscar...",
        "searchresults": "",
        "selectdate": "",
        "selected": "",
        "sendagain": "",
        "sendby": "",
        "settings": "",
        "signin": "",
        "sms": "",
        "status": "",
        "sub_status": {
          "expired": ""
        },
        "successful": "",
        "sunday": "",
        "text": "",
        "thursday": "",
        "time": "",
        "total": "",
        "totals": "",
        "tuesday": "",
        "tvmode": "",
        "unknown": "Desconocido",
        "unsavedchanges": "Cambios sin guardar",
        "username": "",
        "validationerror": "",
        "view": "",
        "wednesday": "",
        "yes": ""
      },
      "languages": {
        "english": "Inglés",
        "french": "francés",
        "spanish": "español"
      },
      "messages": {
        "exception": "",
        "newversionmessage": "",
        "newversiontitle": "",
        "noacctfilepath": "",
        "nofeatureaccess": "",
        "noshop": "",
        "notfoundsub": "",
        "notfoundtitle": "",
        "partnernotrunning": "",
        "rbacunauth": "",
        "submit-for-testing": "",
        "unsavedchanges": "Usted tiene cambios no guardados.",
        "unsavedchangespopup": "Tiene cambios sin guardar. ¿Está seguro de que desea salir?"
      },
      "validation": {
        "array": "Por favor seleccione al menos una opción.",
        "dateRangeExceeded": "",
        "invalidemail": "Por favor introduzca una dirección de correo electrónico válida.",
        "invalidphone": "",
        "minlength": "Debe tener al menos {{min}} caracteres.",
        "required": "Este campo es requerido."
      }
    },
    "help": {
      "actions": {
        "connect": ""
      },
      "labels": {
        "codeplacholder": "",
        "rescuedesc": "",
        "rescuetitle": ""
      }
    },
    "intake": {
      "labels": {
        "printpack": ""
      }
    },
    "inventory": {
      "actions": {
        "addtoinventory": "",
        "addtoro": "",
        "consumefrominventory": "",
        "edit": "",
        "new": ""
      },
      "errors": {
        "inserting": ""
      },
      "fields": {
        "comment": "",
        "manualinvoicenumber": "",
        "manualvendor": ""
      },
      "labels": {
        "consumedbyjob": "",
        "deleteconfirm": "",
        "frombillinvoicenumber": "",
        "fromvendor": "",
        "inventory": "",
        "showall": "",
        "showavailable": ""
      },
      "successes": {
        "deleted": "",
        "inserted": "",
        "updated": ""
      }
    },
    "job_lifecycle": {
      "columns": {
        "average_human_readable": "",
        "average_value": "",
        "duration": "",
        "end": "",
        "human_readable": "",
        "percentage": "",
        "relative_end": "",
        "relative_start": "",
        "start": "",
        "status": "",
        "status_count": "",
        "value": ""
      },
      "content": {
        "calculated_based_on": "",
        "current_status_accumulated_time": "",
        "data_unavailable": "",
        "jobs_in_since": "",
        "legend_title": "",
        "loading": "",
        "not_available": "",
        "previous_status_accumulated_time": "",
        "title": "",
        "title_durations": "",
        "title_loading": "",
        "title_transitions": ""
      },
      "errors": {
        "fetch": "Error al obtener los datos del ciclo de vida del trabajo"
      },
      "titles": {
        "dashboard": "",
        "top_durations": ""
      }
    },
    "job_payments": {
      "buttons": {
        "create_short_link": "",
        "goback": "",
        "proceedtopayment": "",
        "refundpayment": ""
      },
      "notifications": {
        "error": {
          "description": "",
          "openingip": "",
          "title": ""
        }
      },
      "titles": {
        "amount": "",
        "dateOfPayment": "",
        "descriptions": "",
        "hint": "",
        "payer": "",
        "payername": "",
        "paymentid": "",
        "paymentnum": "",
        "paymenttype": "",
        "refundamount": "",
        "transactionid": ""
      }
    },
    "joblines": {
      "actions": {
        "assign_team": "",
        "converttolabor": "",
        "dispatchparts": "",
        "new": "",
        "revertprice": "Restablecer",
        "save_add_another": "Guardar y agregar otra",
        "updatelocation": ""
      },
      "errors": {
        "creating": "",
        "updating": ""
      },
      "fields": {
        "act_price": "Precio actual",
        "act_price_before_ppc": "",
        "adjustment": "",
        "ah_detail_line": "",
        "alt_partno": "",
        "amount": "",
        "assigned_team": "",
        "assigned_team_name": "",
        "cost_only": "Solo costo",
        "create_ppc": "",
        "db_price": "Precio de base de datos",
        "include_in_part_cnt": "",
        "lbr_types": {
          "LA1": "",
          "LA2": "",
          "LA3": "",
          "LA4": "",
          "LAA": "",
          "LAB": "",
          "LAD": "",
          "LAE": "",
          "LAF": "",
          "LAG": "",
          "LAM": "",
          "LAR": "",
          "LAS": "",
          "LAU": ""
        },
        "line_desc": "Descripción de línea",
        "line_ind": "S#",
        "line_kind": "Tipo de línea",
        "line_no": "",
        "location": "",
        "mod_lb_hrs": "Horas laborales",
        "mod_lbr_ty": "Tipo de trabajo",
        "notes": "",
        "oem_partno": "OEM parte #",
        "op_code_desc": "",
        "part_qty": "",
        "part_type": "Tipo de parte",
        "part_types": {
          "CCC": "",
          "CCD": "",
          "CCDR": "",
          "CCF": "",
          "CCM": "",
          "PAA": "",
          "PAC": "",
          "PAE": "",
          "PAG": "",
          "PAL": "",
          "PAM": "",
          "PAN": "",
          "PAO": "",
          "PAP": "",
          "PAR": "",
          "PAS": "",
          "PASL": ""
        },
        "profitcenter_labor": "",
        "profitcenter_part": "",
        "prt_dsmk_m": "",
        "prt_dsmk_p": "",
        "status": "Estado",
        "tax_part": "",
        "total": "",
        "unq_seq": "Seq #"
      },
      "kinds": {
        "both": "Mano de obra + pieza",
        "fee": "Cargo / otro",
        "labor": "Mano de obra",
        "part": "Pieza"
      },
      "labels": {
        "adjustmenttobeadded": "",
        "ah_detail_line_help": "Disponible para tipos de mano de obra definidos por el usuario (LA1–LA4, LAU).",
        "apply_preset": "Aplicar preajuste…",
        "billref": "",
        "bulk_location_help": "",
        "convertedtolabor": "",
        "cost_only_banner": "Esta línea se excluye de los totales y los impuestos, pero sigue apareciendo en el pedido de piezas y la mano de obra. Se resalta en naranja en la tabla de líneas del presupuesto.",
        "cost_only_help": "Las líneas de solo costo se excluyen de los totales del trabajo, pero siguen apareciendo en piezas y mano de obra.",
        "discount_applied": "= {{amount}} aplicado a esta línea",
        "discount_markup": "Descuento / margen",
        "edit": "Línea de edición",
        "excluded_from_totals": "Excluido de los totales",
        "hours_required_hint": "Obligatorio cuando se selecciona un tipo de mano de obra",
        "include_in_part_cnt_help": "Disponible cuando el precio de venta es $0.00.",
        "ioucreated": "",
        "manuallineprice": "Las líneas manuales se cotizan desde la acción de edición de la línea, no desde esta ventana emergente.",
        "new": "Nueva línea",
        "nostatus": "",
        "not_set_by_preset": "No definido por este preajuste",
        "preset_applied": "Preajuste aplicado — los campos resaltados fueron rellenados por {{label}}; todo sigue siendo editable.",
        "presets": "",
        "tax_part_help": "Incluir esta línea en el cálculo de impuestos."
      },
      "sections": {
        "fee": "Importe",
        "labor": "Mano de obra",
        "line": "Detalles de la línea",
        "options": "Opciones",
        "parts": "Piezas y precios"
      },
      "successes": {
        "created": "",
        "saved": "",
        "updated": ""
      },
      "validations": {
        "ahdetailonlyonuserdefinedtypes": "",
        "hrsrequirediflbrtyp": "",
        "requiredifparttype": "",
        "zeropriceexistingpart": ""
      }
    },
    "jobs": {
      "actions": {
        "addDocuments": "Agregar documentos de trabajo",
        "addNote": "Añadir la nota",
        "addpayer": "",
        "addtopartsqueue": "",
        "removefrompartsqueue": "Quitar de la cola de piezas",
        "addtoproduction": "",
        "addtoscoreboard": "",
        "allocate": "",
        "autoallocate": "",
        "changefilehandler": "",
        "changelaborrate": "",
        "changestatus": "Cambiar Estado",
        "changestimator": "",
        "convert": "Convertir",
        "convertwithoutearlyro": "",
        "createiou": "",
        "deliver": "",
        "deliver_quick": "",
        "dms": {
          "addpayer": "",
          "createearlyro": "",
          "createnewcustomer": "",
          "findmakemodelcode": "",
          "getmakes": "",
          "labels": {
            "refreshallocations": ""
          },
          "post": "",
          "refetchmakesmodels": "",
          "update_ro": "",
          "usegeneric": "",
          "useselected": ""
        },
        "dmsautoallocate": "",
        "export": "",
        "exportcustdata": "",
        "exportselected": "",
        "filterpartsonly": "",
        "generatecsi": "",
        "gotojob": "",
        "intake": "",
        "intake_quick": "",
        "manualnew": "",
        "mark": "",
        "markasexported": "",
        "markpstexempt": "",
        "markpstexemptconfirm": "",
        "postbills": "Contabilizar facturas",
        "printCenter": "Centro de impresión",
        "recalculate": "",
        "reconcile": "",
        "removefromproduction": "",
        "schedule": "Programar",
        "sendcsi": "",
        "sendpartspricechange": "",
        "sendtodms": "",
        "sync": "",
        "taxprofileoverride": "",
        "taxprofileoverride_confirm": "",
        "uninvoice": "",
        "unvoid": "",
        "viewchecklist": "",
        "viewdetail": ""
      },
      "errors": {
        "addingtoproduction": "",
        "cannotintake": "",
        "closing": "",
        "creating": "",
        "deleted": "Error al eliminar el trabajo.",
        "exporting": "",
        "exporting-partner": "",
        "invalidjoblines": "",
        "invoicing": "",
        "missingjoblineids": "",
        "noaccess": "Este trabajo no existe o no tiene acceso a él.",
        "nodamage": "",
        "nodates": "No hay fechas especificadas para este trabajo.",
        "nofinancial": "",
        "nojobselected": "No hay trabajo seleccionado.",
        "noowner": "Ningún propietario asociado.",
        "novehicle": "No hay vehículo asociado.",
        "partspricechange": "",
        "saving": "Se encontró un error al guardar el registro.",
        "scanimport": "",
        "totalscalc": "",
        "updating": "",
        "validation": "Asegúrese de que todos los campos se ingresen correctamente.",
        "validationtitle": "Error de validacion",
        "voiding": ""
      },
      "fields": {
        "active_tasks": "",
        "actual_completion": "Realización real",
        "actual_delivery": "Entrega real",
        "actual_in": "Real en",
        "acv_amount": "",
        "adjustment_bottom_line": "Ajustes",
        "adjustmenthours": "",
        "admin_clerk": "",
        "alt_transport": "",
        "area_of_damage_impact": {
          "10": "",
          "11": "",
          "12": "",
          "13": "",
          "14": "",
          "15": "",
          "16": "",
          "25": "",
          "26": "",
          "27": "",
          "28": "",
          "34": "",
          "01": "",
          "02": "",
          "03": "",
          "04": "",
          "05": "",
          "06": "",
          "07": "",
          "08": "",
          "09": ""
        },
        "auto_add_ats": "",
        "ca_bc_pvrt": "",
        "ca_customer_gst": "",
        "ca_gst_registrant": "",
        "category": "",
        "ccc": "",
        "ccd": "",
        "ccdr": "",
        "ccf": "",
        "ccm": "",
        "cieca_id": "CIECA ID",
        "cieca_pfl": {
          "lbr_adjp": "",
          "lbr_tax_in": "",
          "lbr_taxp": "",
          "lbr_tx_in1": "",
          "lbr_tx_in2": "",
          "lbr_tx_in3": "",
          "lbr_tx_in4": "",
          "lbr_tx_in5": ""
        },
        "cieca_pfo": {
          "stor_t_in1": "",
          "stor_t_in2": "",
          "stor_t_in3": "",
          "stor_t_in4": "",
          "stor_t_in5": "",
          "tow_t_in1": "",
          "tow_t_in2": "",
          "tow_t_in3": "",
          "tow_t_in4": "",
          "tow_t_in5": ""
        },
        "claim_total": "Reclamar total",
        "class": "",
        "clm_no": "Reclamación #",
        "clm_total": "Reclamar total",
        "comment": "",
        "customerowing": "Cliente debido",
        "date_estimated": "Fecha estimada",
        "date_exported": "Exportado",
        "date_invoiced": "Facturado",
        "date_last_contacted": "",
        "date_lost_sale": "",
        "date_next_contact": "",
        "date_open": "Abierto",
        "date_rentalresp": "",
        "date_repairstarted": "",
        "date_scheduled": "Programado",
        "date_towin": "",
        "date_void": "",
        "ded_amt": "Deducible",
        "ded_note": "",
        "ded_status": "Estado deducible",
        "depreciation_taxes": "Depreciación / Impuestos",
        "dms": {
          "IsARCustomer": "",
          "address": "",
          "advisor": "",
          "amount": "",
          "center": "",
          "control_type": {
            "account_number": ""
          },
          "cost": "",
          "cost_dms_acctnumber": "",
          "customer": "",
          "dms_make": "",
          "dms_model": "",
          "dms_model_override": "",
          "dms_unsold": "",
          "dms_wip_acctnumber": "",
          "first_name": "",
          "id": "",
          "inservicedate": "",
          "journal": "",
          "last_name": "",
          "lines": "",
          "make_override": "",
          "name1": "",
          "payer": {
            "amount": "",
            "control_type": "",
            "controlnumber": "",
            "dms_acctnumber": "",
            "name": "",
            "payer_type": ""
          },
          "rr_opcode": "",
          "rr_opcode_base": "",
          "rr_opcode_prefix": "",
          "rr_opcode_suffix": "",
          "sale": "",
          "sale_dms_acctnumber": "",
          "story": "",
          "vinowner": ""
        },
        "dms_allocation": "",
        "driveable": "",
        "employee_body": "",
        "employee_csr": "Representante de servicio al cliente.",
        "employee_csr_writer": "",
        "employee_prep": "",
        "employee_refinish": "",
        "est_addr1": "Dirección del tasador",
        "est_co_nm": "Tasador",
        "est_co_nm_short": "",
        "est_ct_fn": "Nombre del tasador",
        "est_ct_fn_short": "",
        "est_ct_ln": "Apellido del tasador",
        "est_ct_ln_short": "",
        "est_ea": "Correo electrónico del tasador",
        "est_ea_short": "",
        "est_ph1": "Número de teléfono del tasador",
        "est_ph1_short": "",
        "estimate_approved": "",
        "estimate_sent_approval": "",
        "federal_tax_payable": "Impuesto federal por pagar",
        "federal_tax_rate": "",
        "flat_rate_ats": "",
        "hit_and_run": "",
        "ins_addr1": "Dirección de Insurance Co.",
        "ins_city": "Ciudad de seguros",
        "ins_co_id": "ID de la compañía de seguros",
        "ins_co_nm": "Nombre de la compañía de seguros",
        "ins_co_nm_short": "",
        "ins_ct_fn": "Nombre del controlador de archivos",
        "ins_ct_fn_short": "",
        "ins_ct_ln": "Apellido del manejador de archivos",
        "ins_ct_ln_short": "",
        "ins_ea": "Correo electrónico del controlador de archivos",
        "ins_ea_short": "",
        "ins_ph1": "File Handler Phone #",
        "ins_ph1_short": "",
        "intake": {
          "label": "",
          "max": "",
          "min": "",
          "name": "",
          "required": "",
          "type": ""
        },
        "invoice_final_note": "",
        "kmin": "Kilometraje en",
        "kmout": "Kilometraje",
        "la1": "",
        "la2": "",
        "la3": "",
        "la4": "",
        "laa": "",
        "lab": "",
        "labor_rate_desc": "Nombre de la tasa laboral",
        "lad": "",
        "lae": "",
        "laf": "",
        "lag": "",
        "lam": "",
        "lar": "",
        "las": "",
        "lau": "",
        "local_tax_rate": "",
        "loss_date": "Fecha de pérdida",
        "loss_desc": "",
        "loss_of_use": "",
        "lost_sale_reason": "",
        "ma2s": "",
        "ma3s": "",
        "mabl": "",
        "macs": "",
        "mahw": "",
        "mapa": "",
        "mash": "",
        "matd": "",
        "materials": {
          "MAPA": "",
          "MASH": "",
          "cal_maxdlr": "",
          "cal_opcode": "",
          "mat_adjp": "",
          "mat_taxp": "",
          "mat_tx_in1": "",
          "mat_tx_in2": "",
          "mat_tx_in3": "",
          "mat_tx_in4": "",
          "mat_tx_in5": "",
          "materials": "",
          "tax_ind": ""
        },
        "other_amount_payable": "Otra cantidad a pagar",
        "owner": "Propietario",
        "owner_owing": "Cust. Debe",
        "ownr_ea": "Email",
        "ownr_ph1": "Teléfono 1",
        "ownr_ph2": "",
        "paa": "",
        "pac": "",
        "pae": "",
        "pag": "",
        "pal": "",
        "pam": "",
        "pan": "",
        "pao": "",
        "pap": "",
        "par": "",
        "parts_tax_rates": {
          "prt_discp": "",
          "prt_mktyp": "",
          "prt_mkupp": "",
          "prt_tax_in": "",
          "prt_tax_rt": "",
          "prt_tx_in1": "",
          "prt_tx_in2": "",
          "prt_tx_in3": "",
          "prt_tx_in4": "",
          "prt_tx_in5": "",
          "prt_tx_ty1": "",
          "prt_type": ""
        },
        "partsstatus": "",
        "pas": "",
        "pay_date": "Fecha de Pay",
        "phoneshort": "PH",
        "po_number": "",
        "policy_no": "Política #",
        "ponumber": "numero postal",
        "production_vars": {
          "note": ""
        },
        "qb_multiple_payers": {
          "amount": "",
          "name": ""
        },
        "queued_for_parts": "",
        "rate_ats": "",
        "rate_ats_flat": "",
        "rate_la1": "Tarifa LA1",
        "rate_la2": "Tarifa LA2",
        "rate_la3": "Tarifa LA3",
        "rate_la4": "Tarifa LA4",
        "rate_laa": "Tasa de aluminio",
        "rate_lab": "Tasa de trabajo",
        "rate_lad": "Tasa de diagnóstico",
        "rate_lae": "tarifa eléctrica",
        "rate_laf": "Cuadros por segundo",
        "rate_lag": "Tasa de vidrio",
        "rate_lam": "Tasa mecánica",
        "rate_lar": "Tasa de acabado",
        "rate_las": "",
        "rate_lau": "",
        "rate_ma2s": "Velocidad de pintura de 2 etapas",
        "rate_ma3s": "Tasa de pintura de 3 etapas",
        "rate_mabl": "MABL ??",
        "rate_macs": "MACS ??",
        "rate_mahw": "Tasa de residuos peligrosos",
        "rate_mapa": "Tasa de materiales de pintura",
        "rate_mash": "Comprar material de tarifa",
        "rate_matd": "Tasa de eliminación de neumáticos",
        "referral_source_extra": "",
        "referral_source_other": "",
        "referralsource": "Fuente de referencia",
        "regie_number": "N. ° de registro",
        "repairtotal": "Reparación total",
        "ro_number": "RO #",
        "scheduled_completion": "Finalización programada",
        "scheduled_delivery": "Entrega programada",
        "scheduled_in": "Programado en",
        "selling_dealer": "Distribuidor vendedor",
        "selling_dealer_contact": "Contacto con el vendedor",
        "servicecar": "Auto de servicio",
        "servicing_dealer": "Distribuidor de servicio",
        "servicing_dealer_contact": "Servicio Contacto con el concesionario",
        "special_coverage_policy": "Política de cobertura especial",
        "specialcoveragepolicy": "Política de cobertura especial",
        "state_tax_rate": "",
        "status": "Estado del trabajo",
        "storage_payable": "Almacenamiento ",
        "tax_lbr_rt": "",
        "tax_levies_rt": "",
        "tax_paint_mat_rt": "",
        "tax_registration_number": "",
        "tax_shop_mat_rt": "",
        "tax_str_rt": "",
        "tax_sub_rt": "",
        "tax_tow_rt": "",
        "tlos_ind": "",
        "towin": "",
        "towing_payable": "Remolque a pagar",
        "unitnumber": "Unidad #",
        "updated_at": "Actualizado en",
        "uploaded_by": "Subido por",
        "vehicle": "Vehículo"
      },
      "forms": {
        "admindates": "",
        "appraiserinfo": "",
        "claiminfo": "",
        "estdates": "",
        "laborrates": "",
        "lossinfo": "",
        "other": "",
        "repairdates": "",
        "scheddates": ""
      },
      "labels": {
        "esignatures": "",
        "accountsreceivable": "",
        "act_price_ppc": "",
        "actual_completion_inferred": "",
        "actual_delivery_inferred": "",
        "actual_in_inferred": "",
        "additionalpayeroverallocation": "",
        "additionaltotal": "",
        "adjustmentrate": "",
        "adjustments": "",
        "adminwarning": "",
        "allocations": "",
        "alreadyaddedtoscoreboard": "",
        "alreadyclosed": "",
        "appointmentconfirmation": "¿Enviar confirmación al cliente?",
        "approved": "",
        "associationwarning": "",
        "audit": "",
        "available": "",
        "availablejobs": "",
        "ca_bc_pvrt": {
          "days": "",
          "rate": ""
        },
        "ca_gst_all_if_null": "",
        "calc_repair_days": "",
        "calc_repair_days_tt": "",
        "calc_scheuled_completion": "",
        "cards": {
          "customer": "Información al cliente",
          "damage": "Área de Daño",
          "dates": "fechas",
          "documents": "Documentos recientes",
          "estimator": "Estimador",
          "filehandler": "File Handler",
          "insurance": "detalles del seguro",
          "more": "Más",
          "notes": "Notas",
          "parts": "Partes",
          "totals": "Totales",
          "vehicle": "Vehículo"
        },
        "changeclass": "",
        "checklistcompletedby": "",
        "checklistdocuments": "",
        "checklists": "",
        "cieca_pfl": "",
        "cieca_pfo": "",
        "cieca_pft": "",
        "closeconfirm": "",
        "closejob": "",
        "closingperiod": "",
        "contracts": "",
        "convert": {
          "driveabledesc": "El vehículo puede salir del taller por sus propios medios una vez finalizadas las reparaciones.",
          "earlyrogatedesc": "Este taller envía datos a Reynolds & Reynolds. Reserve primero un número de RO a continuación — el resto de este formulario se desbloqueará una vez creado.",
          "earlyrogatefooterhint": "Cree la RO anticipada de arriba antes de convertir.",
          "earlyrogatetitle": "Se requiere una RO anticipada antes de convertir",
          "gstdesc": "El cliente está registrado para el GST — cambia cómo se aplican los impuestos en esta RO.",
          "requirements": "Requisitos de conversión",
          "towindesc": "El vehículo llegó remolcado y no se puede conducir en su estado actual.",
          "vehiclestatus": "Estado del vehículo y facturación"
        },
        "convertedtolabor": "",
        "cost": "",
        "cost_Additional": "",
        "cost_labor": "",
        "cost_parts": "",
        "cost_sublet": "",
        "costs": "",
        "create": {
          "jobinfo": "",
          "newowner": "",
          "newvehicle": "",
          "novehicle": "",
          "ownerinfo": "",
          "vehicleinfo": ""
        },
        "createiouwarning": "",
        "creating_new_job": "Creando nuevo trabajo ...",
        "deductible": {
          "stands": "",
          "waived": ""
        },
        "deleteconfirm": "",
        "deletedelivery": "",
        "deleteintake": "",
        "deletewatchers": "",
        "deliverchecklist": "",
        "difference": "",
        "diskscan": "",
        "dms": {
          "apexported": "",
          "damageto": "",
          "defaultstory": "",
          "disablebillwip": "",
          "earlyro": {
            "created": "",
            "fields": "",
            "willupdate": ""
          },
          "invoicedatefuture": "",
          "kmoutnotgreaterthankmin": "",
          "logs": "",
          "notallocated": "",
          "postingform": "",
          "totalallocated": ""
        },
        "documents": "documentos",
        "documents-images": "",
        "documents-other": "",
        "duplicateconfirm": "",
        "emailaudit": "",
        "employeeassignments": "",
        "esignature_imex": "",
        "esignature_rome": "",
        "estimatelines": "",
        "estimator": "",
        "existing_jobs": "Empleos existentes",
        "federal_tax_amt": "",
        "gpdollars": "",
        "gppercent": "",
        "hrs_claimed": "",
        "hrs_total": "",
        "importnote": "",
        "inproduction": "",
        "intakechecklist": "",
        "iou": "",
        "job": "",
        "jobcosting": "",
        "jobtotals": "",
        "labor_hrs": "",
        "labor_rates_subtotal": "",
        "laborallocations": "",
        "labortotals": "",
        "lines": "Líneas estimadas",
        "local_tax_amt": "",
        "mapa": "",
        "markforreexport": "",
        "mash": "",
        "masterbypass": "",
        "materials": {
          "mapa": ""
        },
        "missingprofileinfo": "",
        "multipayers": "",
        "net_repairs": "",
        "notes": "Notas",
        "othertotal": "",
        "outstanding_ar": "",
        "outstanding_credit_memos": "",
        "outstanding_ppd": "",
        "outstanding_reconciliation_discrep": "",
        "outstanding_sublets": "",
        "outstandinghours": "",
        "override_header": "¿Anular encabezado estimado al importar?",
        "ownerassociation": "",
        "parts": "Partes",
        "parts_lines": "",
        "parts_received": "",
        "parts_tax_rates": "",
        "partsfilter": "",
        "partssubletstotal": "",
        "partstotal": "",
        "performance": "",
        "pimraryamountpayable": "",
        "plitooltips": {
          "billtotal": "",
          "calculatedcreditsnotreceived": "",
          "creditmemos": "",
          "creditsnotreceived": "",
          "discrep1": "",
          "discrep2": "",
          "discrep3": "",
          "laboradj": "",
          "partstotal": "",
          "totalreturns": ""
        },
        "ppc": "",
        "ppdnotexported": "",
        "profileadjustments": "",
        "profitbypassrequired": "",
        "profits": "",
        "prt_dsmk_total": "",
        "rates": "Tarifas",
        "rates_subtotal": "",
        "reconciliation": {
          "billlinestotal": "",
          "byassoc": "",
          "byprice": "",
          "clear": "",
          "discrepancy": "",
          "joblinestotal": "",
          "multipleactprices": "",
          "multiplebilllines": "",
          "multiplebillsforactprice": "",
          "removedpartsstrikethrough": ""
        },
        "reconciliationheader": "",
        "relatedros": "",
        "remove_from_ar": "",
        "returntotals": "",
        "ro_guard": {
          "enforce_ar": "",
          "enforce_bills": "",
          "enforce_cm": "",
          "enforce_labor": "",
          "enforce_ppd": "",
          "enforce_profit": "",
          "enforce_sublet": "",
          "enforce_validation": "",
          "enforced": ""
        },
        "roguard": "",
        "roguardwarnings": "",
        "rosaletotal": "",
        "sale_additional": "",
        "sale_labor": "",
        "sale_parts": "",
        "sale_sublet": "",
        "sales": "",
        "savebeforeconversion": "",
        "scheduledinchange": "",
        "sent": "",
        "specialcoveragepolicy": "",
        "state_tax_amt": "",
        "subletsnotcompleted": "",
        "subletstotal": "",
        "subtotal": "",
        "supplementnote": "",
        "suspended": "",
        "suspense": "",
        "tasks": "",
        "threshhold": "",
        "total_cost": "",
        "total_cust_payable": "",
        "total_cust_payable_cash_discount": "",
        "total_repairs": "",
        "total_repairs_cash_discount": "",
        "total_sales": "",
        "total_sales_tax": "",
        "totals": "",
        "unvoidnote": "",
        "update_scheduled_completion": "",
        "vehicle_info": "Vehículo",
        "vehicleassociation": "",
        "viewallocations": "",
        "voidjob": "",
        "voidnote": ""
      },
      "successes": {
        "addedtoproduction": "",
        "all_deleted": "{{count}} trabajos eliminados con éxito.",
        "closed": "",
        "converted": "Trabajo convertido con éxito.",
        "created": "Trabajo creado con éxito. Click para ver.",
        "creatednoclick": "",
        "delete": "",
        "deleted": "Trabajo eliminado con éxito.",
        "duplicated": "",
        "early_ro_created": "",
        "exported": "",
        "invoiced": "",
        "ioucreated": "",
        "partsqueue": "",
        "partsqueue_removed": "Trabajo eliminado de la cola de piezas.",
        "save": "Trabajo guardado con éxito.",
        "savetitle": "Registro guardado con éxito.",
        "supplemented": "Trabajo complementado con éxito.",
        "updated": "",
        "voided": ""
      }
    },
    "jobtimeline": {
      "categories": {
        "activity": "Actividad",
        "documents": "Documentos",
        "emails": "Correos",
        "esign": "Firmas electrónicas",
        "messages": "Mensajes",
        "notes": "Notas",
        "parts": "Piezas",
        "payments": "Pagos",
        "status": "Estado"
      },
      "empty": "Aún no hay eventos para esta orden.",
      "events": {
        "bill": "Factura {{invoice_number}} recibida de {{vendor}}",
        "document": "Documento agregado: {{name}}",
        "email": "Correo enviado: {{subject}}",
        "esign_completed": "Firma electrónica completada: {{title}}",
        "esign_sent": "Firma electrónica solicitada: {{title}}",
        "message_image": "(Imagen adjunta)",
        "message_received": "Mensaje de texto recibido",
        "message_sent": "Mensaje de texto enviado",
        "message_system": "Mensaje del sistema",
        "parts_dispatch": "Despacho de piezas n.º {{number}} ({{count}} líneas)",
        "parts_order": "Pedido de piezas n.º {{order_number}} realizado a {{vendor}} ({{count}} líneas)",
        "parts_return": "Devolución de piezas n.º {{order_number}} a {{vendor}} ({{count}} líneas)",
        "parts_sublet": "",
        "payment": "Pago recibido ({{type}}) de {{payer}}",
        "quote_suffix": ""
      },
      "filetypes": {
        "document": "Documento",
        "image": "Imagen",
        "pdf": "PDF",
        "video": "Video"
      },
      "open": "Abrir",
      "showmore": "Mostrar {{count}} más",
      "tab": "Cronología",
      "updated": "Actualizado"
    },
    "landing": {
      "bigfeature": {
        "subtitle": "",
        "title": ""
      },
      "footer": {
        "company": {
          "about": "",
          "contact": "",
          "disclaimers": "",
          "name": "",
          "privacypolicy": ""
        },
        "io": {
          "help": "",
          "name": "",
          "status": ""
        },
        "slogan": ""
      },
      "hero": {
        "button": "",
        "title": ""
      },
      "labels": {
        "features": "",
        "managemyshop": "",
        "pricing": ""
      },
      "pricing": {
        "basic": {
          "name": "",
          "sub": ""
        },
        "essentials": {
          "name": "",
          "sub": ""
        },
        "pricingtitle": "",
        "pro": {
          "name": "",
          "sub": ""
        },
        "title": "",
        "unlimited": {
          "name": "",
          "sub": ""
        }
      }
    },
    "menus": {
      "currentuser": {
        "languageselector": "idioma",
        "profile": "Perfil"
      },
      "header": {
        "accounting": "",
        "accounting-payables": "",
        "accounting-payments": "",
        "accounting-receivables": "",
        "activejobs": "Empleos activos",
        "all_tasks": "",
        "alljobs": "",
        "allpayments": "",
        "availablejobs": "Trabajos disponibles",
        "bills": "",
        "courtesycars": "",
        "courtesycars-all": "",
        "courtesycars-contracts": "",
        "courtesycars-newcontract": "",
        "create_task": "",
        "customers": "Clientes",
        "dashboard": "",
        "enterbills": "",
        "entercardpayment": "",
        "enterpayment": "",
        "entertimeticket": "",
        "export": "",
        "export-logs": "",
        "help": "",
        "home": "Casa",
        "inventory": "",
        "jobs": "Trabajos",
        "my_tasks": "",
        "newjob": "",
        "owners": "propietarios",
        "parts-queue": "",
        "phonebook": "",
        "productionboard": "",
        "productionlist": "",
        "readyjobs": "",
        "recent": "",
        "remoteassist": "",
        "reportcenter": "",
        "rescueme": "",
        "rescuemezoho": "",
        "schedule": "Programar",
        "scoreboard": "",
        "search": {
          "bills": "",
          "jobs": "",
          "owners": "",
          "payments": "",
          "phonebook": "",
          "vehicles": ""
        },
        "shiftclock": "",
        "shop": "Mi tienda",
        "shop_config": "Configuración",
        "shop_csi": "",
        "shop_templates": "",
        "shop_vendors": "Vendedores",
        "tasks": "",
        "temporarydocs": "",
        "timetickets": "",
        "ttapprovals": "",
        "vehicles": "Vehículos"
      },
      "jobsactions": {
        "admin": "",
        "cancelallappointments": "",
        "closejob": "",
        "deletejob": "",
        "duplicate": "",
        "duplicatenolines": "",
        "newcccontract": "",
        "sections": {
          "appointments": "Appointments",
          "billing": "Billing",
          "checklists": "Checklists & Delivery",
          "communication": "Customer & Communication",
          "job_tools": "Job Tools",
          "production": "Production",
          "time_tasks": "Time & Tasks"
        },
        "submit-for-testing": "",
        "void": ""
      },
      "jobsdetail": {
        "claimdetail": "Detalles de la reclamación",
        "dates": "fechas",
        "financials": "",
        "general": "",
        "insurance": "",
        "labor": "Labor",
        "lifecycle": "",
        "parts": "",
        "partssublet": "Piezas / Subarrendamiento",
        "rates": "",
        "repairdata": "Datos de reparación",
        "totals": ""
      },
      "profilesidebar": {
        "profile": "Mi perfil",
        "shops": "Mis tiendas"
      },
      "tech": {
        "assignedjobs": "",
        "claimtask": "",
        "dispatchedparts": "",
        "home": "",
        "jobclockin": "",
        "jobclockout": "",
        "joblookup": "",
        "login": "",
        "logout": "",
        "productionboard": "",
        "productionlist": "",
        "shiftclockin": ""
      }
    },
    "messaging": {
      "actions": {
        "back_to_conversations": "Volver a las conversaciones",
        "link": "",
        "new": "",
        "openchat": "",
        "preview_media": "Vista previa de la imagen en tamaño completo"
      },
      "errors": {
        "download_image": "Error al descargar la imagen. {{message}}",
        "invalidphone": "",
        "no_consent": "",
        "noattachedjobs": "",
        "save_image": "Error al guardar la imagen en el trabajo. {{message}}",
        "updatinglabel": ""
      },
      "labels": {
        "active": "Activas",
        "addlabel": "Agregar una etiqueta a esta conversación.",
        "archive": "Archivar",
        "archived": "Archivadas",
        "archived_read_only": "Esta conversación está archivada y es de solo lectura.",
        "conversation_list_mode": "Vista de la lista de conversaciones",
        "earlier": "Anteriores",
        "edit_label": "Editar etiqueta",
        "live": "En vivo",
        "mark_unread": "Marcar como no leído",
        "more_jobs": "+{{count}} más",
        "maxtenimages": "Solo puede seleccionar un máximo de 10 imágenes a la vez.",
        "messaging": "Mensajería",
        "no_consent": "Excluido",
        "no_job_media": "No se encontraron archivos multimedia para este trabajo.",
        "no_media_for_tag": "No hay archivos multimedia que coincidan con esta etiqueta.",
        "noallowtxt": "Este cliente no ha indicado que autoriza el envío de mensajes.",
        "nojobs": "No está asociado a ningún trabajo.",
        "not_converted_abbreviation": "N/A",
        "nopush": "Modo de sondeo activado",
        "phonenumber": "N.º de teléfono",
        "presets": "Respuestas rápidas",
        "page_down": "Página siguiente",
        "page_up": "Página anterior",
        "recentonly": "Aquí solo se muestran las 50 conversaciones más recientes. Para buscar una conversación anterior, abra el contacto relacionado y seleccione su número de teléfono.",
        "ro_chip": "RO {{number}}",
        "save_to_job": "Guardar en los documentos del trabajo",
        "scroll_bottom": "Ir al final",
        "scroll_top": "Ir al principio",
        "search_conversations": "Buscar por nombre, teléfono, etiqueta o RO",
        "select_conversation": "Seleccione una conversación para ver los mensajes.",
        "select_job": "Seleccionar un trabajo",
        "empty_conversation": "Envíe un mensaje para iniciar la conversación.",
        "selectmedia": "Seleccionar contenido multimedia",
        "send_hint_newline": "para una nueva línea",
        "send_hint_send": "para enviar",
        "sentby": "Enviado por {{by}} a las {{time}}",
        "sms_segments": "{{used}} / {{max}} · {{count}} segmento(s) SMS",
        "this_week": "Esta semana",
        "team_member": "Miembro del equipo",
        "today": "Hoy",
        "typeamessage": "Enviar un mensaje...",
        "unarchive": "Desarchivar",
        "unarchive_to_continue": "Desarchive esta conversación para enviar otro mensaje.",
        "unread_messages": "Mensajes no leídos: {{count}}",
        "unlink_job": "Desvincular trabajo"
      },
      "presence": {
        "typing": "{{name}} está escribiendo…",
        "typing_another_window": "Está escribiendo en otra ventana",
        "typing_many": "{{name}} y {{count}} personas más están escribiendo…",
        "viewing": "{{name}} está viendo esta conversación",
        "viewing_many": "{{name}} y {{count}} personas más están viendo esta conversación"
      },
      "relative": {
        "days": "{{count}} d",
        "hours": "{{count}} h",
        "minutes": "{{count}} min",
        "months": "{{count}} mes",
        "now": "ahora",
        "years": "{{count}} a"
      },
      "render": {
        "conversation_list": ""
      }
    },
    "notes": {
      "actions": {
        "actions": "Comportamiento",
        "deletenote": "Borrar nota",
        "edit": "Editar nota",
        "new": "Nueva nota",
        "savetojobnotes": ""
      },
      "errors": {
        "inserting": ""
      },
      "fields": {
        "createdby": "Creado por",
        "critical": "Crítico",
        "pinned": "",
        "private": "Privado",
        "text": "Contenido",
        "type": "",
        "types": {
          "customer": "",
          "general": "",
          "office": "",
          "paint": "",
          "parts": "",
          "shop": "",
          "supplement": "",
          "estimator": ""
        },
        "updatedat": "Actualizado en"
      },
      "labels": {
        "addtorelatedro": "",
        "newnoteplaceholder": "Agrega una nota...",
        "notetoadd": "",
        "pinned_note": "",
        "systemnotes": "",
        "usernotes": ""
      },
      "successes": {
        "create": "Nota creada con éxito.",
        "deleted": "Nota eliminada con éxito.",
        "updated": "Nota actualizada con éxito."
      }
    },
    "notifications": {
      "actions": {
        "remove": ""
      },
      "aria": {
        "toggle": ""
      },
      "channels": {
        "app": "",
        "email": "",
        "fcm": ""
      },
      "labels": {
        "add-watchers": "",
        "add-watchers-team": "",
        "auto-add": "",
        "auto-add-description": "",
        "auto-add-failure": "",
        "auto-add-off": "",
        "auto-add-on": "",
        "auto-add-success": "",
        "employee-notification": "",
        "employee-search": "",
        "mark-all-read": "",
        "new-notification-title": "",
        "no-watchers": "",
        "notification-center": "",
        "notification-popup-title": "",
        "notification-settings-failure": "",
        "notification-settings-success": "",
        "notificationscenarios": "",
        "ro-number": "",
        "save": "",
        "scenario": "",
        "show-unread-only": "",
        "teams-search": "",
        "unwatch": "",
        "watch": "",
        "watching-issue": ""
      },
      "scenarios": {
        "alternate-transport-changed": "",
        "bill-posted": "",
        "critical-parts-status-changed": "",
        "esign-document-completed": "E-Sign Document Completed",
        "esign-document-opened": "E-Sign Document Opened",
        "esign-document-upload-failed": "E-Sign Document Upload Failed",
        "intake-delivery-checklist-completed": "",
        "job-added-to-production": "",
        "job-assigned-to-me": "",
        "job-status-change": "",
        "new-media-added-reassigned": "",
        "new-note-added": "",
        "new-time-ticket-posted": "",
        "part-marked-back-ordered": "",
        "payment-collected-completed": "",
        "schedule-dates-changed": "",
        "supplement-imported": "",
        "tasks-updated-created": ""
      },
      "tooltips": {
        "job-watchers": "",
        "not-employee": "",
        "not-employee-notifications": ""
      }
    },
    "owner": {
      "labels": {
        "noownerinfo": ""
      }
    },
    "owners": {
      "actions": {
        "update": ""
      },
      "errors": {
        "deleting": "",
        "noaccess": "El registro no existe o no tiene acceso a él.",
        "saving": "",
        "selectexistingornew": ""
      },
      "fields": {
        "accountingid": "",
        "address": "Dirección",
        "name": "Nombre",
        "note": "",
        "ownr_addr1": "Dirección",
        "ownr_addr2": "Dirección 2",
        "ownr_city": "ciudad",
        "ownr_co_nm": "",
        "ownr_ctry": "País",
        "ownr_ea": "Email",
        "ownr_fn": "Nombre de pila",
        "ownr_ln": "Apellido",
        "ownr_ph1": "Teléfono 1",
        "ownr_ph2": "",
        "ownr_st": "Provincia del estado",
        "ownr_title": "Título",
        "ownr_zip": "código postal",
        "preferred_contact": "Método de Contacto Preferido",
        "tax_number": ""
      },
      "forms": {
        "address": "",
        "contact": "",
        "name": ""
      },
      "labels": {
        "cell": "",
        "create_new": "Crea un nuevo registro de propietario.",
        "deleteconfirm": "",
        "email": "",
        "existing_owners": "Propietarios existentes",
        "fromclaim": "",
        "fromowner": "",
        "home": "",
        "other": "",
        "phone": "",
        "relatedjobs": "",
        "sms": "",
        "updateowner": "",
        "work": ""
      },
      "successes": {
        "delete": "",
        "save": "Propietario guardado con éxito."
      }
    },
    "parts": {
      "actions": {
        "order": "Pedido de piezas",
        "orderinhouse": ""
      },
      "labels": {
        "view_counts_only": "",
        "view_timestamps": ""
      }
    },
    "parts_dispatch": {
      "actions": {
        "accept": ""
      },
      "errors": {
        "accepting": "",
        "creating": ""
      },
      "fields": {
        "number": "",
        "percent_accepted": ""
      },
      "labels": {
        "notyetdispatched": "",
        "parts_dispatch": ""
      }
    },
    "parts_dispatch_lines": {
      "fields": {
        "accepted_at": ""
      }
    },
    "parts_orders": {
      "actions": {
        "backordered": "",
        "create_return": "",
        "place_order": "",
        "receive": "",
        "receivebill": "",
        "save_quote": ""
      },
      "errors": {
        "associatedbills": "",
        "backordering": "",
        "creating": "Se encontró un error al crear el pedido de piezas.",
        "oec": "",
        "saving": "",
        "updating": ""
      },
      "fields": {
        "act_price": "",
        "backordered_eta": "",
        "backordered_on": "",
        "cm_received": "",
        "comments": "",
        "cost": "",
        "db_price": "",
        "deliver_by": "",
        "job_line_id": "",
        "line_desc": "",
        "line_remarks": "",
        "lineremarks": "Comentarios de línea",
        "oem_partno": "",
        "order_date": "",
        "order_number": "",
        "orderedby": "",
        "part_type": "",
        "quantity": "",
        "return": "",
        "returned_on": "Devuelto el",
        "returnedby": "Devuelto por",
        "status": ""
      },
      "labels": {
        "all": "Todos",
        "allpartsto": "",
        "awaitingcm": "Esperando nota de crédito",
        "backordered": "Pendiente de surtido",
        "cmreceivedstate": "Nota de crédito recibida",
        "cmreceivedsummary": "{{received}} de {{total}} notas de crédito recibidas",
        "confirmdelete": "",
        "cost_from_vendor_discount": "",
        "creditingbill": "Factura a acreditar",
        "customdiscount": "Descuento personalizado",
        "custompercent": "",
        "email": "Enviar por correo electrónico",
        "inthisorder": "Partes en este pedido",
        "inthisreturn": "Partes en esta devolución",
        "is_quote": "",
        "is_quote_help": "",
        "mark_as_received": "",
        "newpartsorder": "",
        "notyetordered": "",
        "oec": "",
        "onthisreturn": "Partes en esta devolución",
        "order_type": "",
        "orderhistory": "Historial de pedidos",
        "overdue": "Atrasado",
        "overduecount": "{{count}} línea(s) atrasada(s)",
        "parts_order": "",
        "parts_orders": "",
        "parts_returns": "",
        "price_discount_applied": "{{percent}}% de descuento",
        "print": "Mostrar formulario impreso",
        "quickdiscount": "Descuento rápido",
        "quote": "",
        "quote_banner": "",
        "receive": "",
        "removefrompartsqueue": "",
        "removefrompartsqueue_help": "",
        "returnpartsorder": "",
        "sublet_order": "",
        "summary_cost": "",
        "summary_lines": "",
        "vendorcontact": "Contacto del proveedor"
      },
      "sections": {
        "options": "",
        "order": "",
        "output": "",
        "return": "Detalles de la devolución"
      },
      "successes": {
        "created": "Pedido de piezas creado con éxito.",
        "line_updated": "",
        "received": "",
        "return_created": ""
      },
      "validations": {
        "atleastoneline": ""
      }
    },
    "payments": {
      "actions": {
        "generatepaymentlink": ""
      },
      "errors": {
        "exporting": "",
        "exporting-partner": "",
        "inserting": ""
      },
      "fields": {
        "amount": "",
        "created_at": "",
        "date": "",
        "exportedat": "",
        "memo": "",
        "payer": "",
        "paymentnum": "",
        "stripeid": "",
        "transactionid": "",
        "type": ""
      },
      "labels": {
        "balance": "",
        "ca_bc_etf_table": "",
        "customer": "",
        "edit": "",
        "electronicpayment": "",
        "external": "",
        "findermodal": "",
        "insurance": "",
        "markexported": "",
        "markforreexport": "",
        "new": "",
        "signup": "",
        "smspaymentreminder": "",
        "title": "",
        "totalpayments": ""
      },
      "successes": {
        "exported": "",
        "markexported": "",
        "markreexported": "",
        "payment": "",
        "paymentupdate": "",
        "stripe": ""
      }
    },
    "phonebook": {
      "actions": {
        "new": "New Phonebook Entry"
      },
      "errors": {
        "adding": "",
        "saving": ""
      },
      "fields": {
        "address1": "",
        "address2": "",
        "category": "",
        "city": "",
        "company": "",
        "country": "",
        "email": "",
        "fax": "",
        "firstname": "",
        "lastname": "",
        "phone1": "",
        "phone2": "",
        "state": ""
      },
      "labels": {
        "entry": "Phonebook Entry",
        "noneselected": "",
        "onenamerequired": "",
        "sections": {
          "address": "Address",
          "communication": "Communication",
          "identity": "Identity",
          "location": "Location"
        },
        "vendorcategory": ""
      },
      "successes": {
        "added": "",
        "deleted": "",
        "saved": ""
      }
    },
    "printcenter": {
      "appointments": {
        "appointment_confirmation": ""
      },
      "banners": {
        "esignature_promo": "¿Cansado de obtener firmas en papel? Prueba {{app}} hoy.",
        "esignature_signup_link": "Registrarse",
        "esignature_signup_tooltip": "Antes de registrarse, confirma que la persona que completa el acuerdo está autorizada para firmar por la empresa y aprobar el acuerdo mensual desde el próximo ciclo de facturación. El precio y los términos actuales se muestran en el formulario."
      },
      "bills": {
        "inhouse_invoice": ""
      },
      "courtesycarcontract": {
        "courtesy_car_contract": "",
        "courtesy_car_impound": "",
        "courtesy_car_inventory": "",
        "courtesy_car_terms": ""
      },
      "errors": {
        "nocontexttype": ""
      },
      "jobs": {
        "3rdpartyfields": {
          "addr1": "",
          "addr2": "",
          "addr3": "",
          "address": "Address",
          "amounts": "Amounts",
          "attn": "",
          "city": "",
          "custgst": "",
          "ded_amt": "",
          "delivery": "Delivery",
          "depreciation": "",
          "location": "Location",
          "other": "",
          "payer": "Choose Payer",
          "payeralert": "Choose either a vendor or an insurance company. Selecting one will disable the other.",
          "payerhint": "Select the third-party payer first, then confirm or adjust the address and invoice amounts.",
          "payerrequired": "Select a vendor or an insurance company.",
          "ponumber": "",
          "reference": "Reference",
          "refnumber": "",
          "selectinsurance": "Select an insurance company",
          "selectvendor": "Select a vendor",
          "sendtype": "",
          "state": "",
          "zip": ""
        },
        "3rdpartypayer": "",
        "ab_proof_of_loss": "",
        "appointment_confirmation": "",
        "appointment_reminder": "",
        "casl_authorization": "",
        "committed_timetickets_ro": "",
        "coversheet_landscape": "",
        "coversheet_portrait": "",
        "csi_invitation": "",
        "csi_invitation_action": "",
        "diagnostic_authorization": "",
        "dms_posting_sheet": "",
        "envelope_return_address": "",
        "estimate": "",
        "estimate_detail": "",
        "estimate_followup": "",
        "express_repair_checklist": "",
        "filing_coversheet_landscape": "",
        "filing_coversheet_portrait": "",
        "final_invoice": "",
        "fippa_authorization": "",
        "folder_label_multiple": "",
        "glass_express_checklist": "",
        "guarantee": "",
        "individual_job_note": "",
        "invoice_customer_payable": "",
        "invoice_total_payable": "",
        "iou_form": "",
        "job_costing_ro": "",
        "job_lifecycle_ro": "",
        "job_notes": "",
        "job_tasks": "",
        "key_tag": "",
        "labels": {
          "count": "",
          "labels": "",
          "position": ""
        },
        "lag_time_ro": "",
        "mechanical_authorization": "",
        "mpi_animal_checklist": "",
        "mpi_eglass_auth": "",
        "mpi_final_acct_sheet": "",
        "mpi_final_repair_acct_sheet": "",
        "paint_grid": "",
        "parts_dispatch": "",
        "parts_invoice_label_single": "",
        "parts_label_multiple": "",
        "parts_label_single": "",
        "parts_list": "",
        "parts_order": "",
        "parts_order_confirmation": "",
        "parts_order_history": "",
        "parts_return_slip": "",
        "payment_receipt": "",
        "payment_request": "",
        "payments_by_job": "",
        "purchases_by_ro_detail": "",
        "purchases_by_ro_summary": "",
        "qc_sheet": "",
        "rental_reservation": "",
        "ro_totals": "",
        "ro_with_description": "",
        "sgi_certificate_of_repairs": "",
        "sgi_windshield_auth": "",
        "stolen_recovery_checklist": "",
        "sublet_order": "",
        "supplement_request": "",
        "thank_you_ro": "",
        "thirdpartypayer": "",
        "timetickets_ro": "",
        "vehicle_check_in": "",
        "vehicle_delivery_check": "",
        "window_tag": "",
        "window_tag_sublet": "",
        "work_authorization": "",
        "worksheet_by_line_number": "",
        "worksheet_sorted_by_operation": "",
        "worksheet_sorted_by_operation_no_hours": "",
        "worksheet_sorted_by_operation_part_type": "",
        "worksheet_sorted_by_operation_type": "",
        "worksheet_sorted_by_team": ""
      },
      "labels": {
        "groups": {
          "authorization": "",
          "financial": "",
          "post": "",
          "pre": "",
          "ro": "",
          "worksheet": ""
        },
        "misc": "",
        "repairorder": "",
        "reportcentermodal": "",
        "speedprint": "",
        "title": ""
      },
      "payments": {
        "ca_bc_etf_table": "",
        "exported_payroll": ""
      },
      "special": {
        "attendance_detail_csv": ""
      },
      "subjects": {
        "jobs": {
          "individual_job_note": "",
          "parts_dispatch": "",
          "parts_order": "",
          "parts_return_slip": "",
          "sublet_order": ""
        }
      },
      "vendors": {
        "purchases_by_vendor_detailed": "",
        "purchases_by_vendor_summary": ""
      }
    },
    "production": {
      "actions": {
        "addcolumns": "",
        "bodypriority-clear": "",
        "bodypriority-set": "",
        "detailpriority-clear": "",
        "detailpriority-set": "",
        "paintpriority-clear": "",
        "paintpriority-set": "",
        "remove": "",
        "removecolumn": "",
        "saveconfig": "",
        "saveprofile": "Guardar perfil",
        "suspend": "",
        "unsuspend": ""
      },
      "constants": {
        "main_profile": ""
      },
      "errors": {
        "boardupdate": "",
        "name_exists": "",
        "name_required": "",
        "removing": "",
        "settings": ""
      },
      "labels": {
        "actual_in": "",
        "addnewprofile": "",
        "alert": "",
        "alertoff": "",
        "alerton": "",
        "alerts": "",
        "ats": "",
        "bodyhours": "",
        "bodypriority": "",
        "bodyshop": {
          "labels": {
            "qbo_departmentid": "",
            "qbo_usa": ""
          }
        },
        "boardprofiles": "Board Profiles",
        "card_size": "",
        "cardcolor": "",
        "cardsettings": "",
        "click_for_statuses": "",
        "clm_no": "",
        "color_by": "Color By",
        "comment": "",
        "compact": "",
        "detailpriority": "",
        "employeeassignments": "",
        "employeesearch": "",
        "estimator": "",
        "horizontal": "",
        "ins_co_nm": "",
        "jobdetail": "",
        "kiosk_mode": "",
        "laborhrs": "",
        "legend": "",
        "model_info": "",
        "note": "",
        "off": "",
        "on": "",
        "orientation": "",
        "ownr_nm": "",
        "paintpriority": "",
        "partsreceived": "",
        "partsstatus": "",
        "production_note": "",
        "refinishhours": "",
        "scheduled_completion": "",
        "selectview": "",
        "stickyheader": "",
        "sublets": "",
        "subtotal": "",
        "tall": "",
        "tasks": "",
        "totalhours": "",
        "touchtime": "",
        "unassigned": "",
        "vertical": "",
        "viewname": "",
        "wide": ""
      },
      "options": {
        "color_body": "Body Technician",
        "color_insurance": "Insurance Company",
        "color_none": "None",
        "color_prep": "Prep Technician",
        "color_refinish": "Refinish Technician",
        "color_severity": "Job Size / Severity",
        "color_writer": "Writer / CSR",
        "horizontal": "",
        "large": "",
        "medium": "",
        "small": "",
        "vertical": ""
      },
      "settings": {
        "board_settings": "",
        "filters": {
          "actual_in_range": "Actual In",
          "alt_transport": "Alternative Transportation",
          "any": "Any",
          "any_date": "Any Date",
          "custom_range": "Custom Range",
          "md_estimators": "",
          "md_ins_cos": "",
          "max": "Max",
          "min": "Min",
          "no_status": "No Status",
          "part_statuses": "Parts Statuses",
          "parts_received": "Parts Received",
          "parts_received_fully_received": "Fully Received",
          "parts_received_has_parts": "Has Parts",
          "parts_received_missing_received": "Missing Received Parts",
          "parts_received_no_parts": "No Parts",
          "parts_received_partially_received": "Partially Received",
          "production_note": "Production Note",
          "scheduled_completion_range": "Scheduled Completion",
          "sublets": "Sublets",
          "subtotal_range": "Subtotal",
          "tasks": "Tasks",
          "technicians": "Technicians / Employees",
          "this_month": "This Month",
          "this_quarter": "This Quarter",
          "this_week": "This Week",
          "this_year": "This Year",
          "vehicle_makes": "Vehicle Makes",
          "with": "With",
          "without": "Without",
          "writers": "Writers / CSRs"
        },
        "filters_title": "",
        "information": "",
        "layout": "",
        "statistics": {
          "exclude_suspended": "",
          "jobs_in_production": "Vehículos en producción",
          "tasks_in_production": "",
          "tasks_in_view": "",
          "tasks_on_board": "",
          "total_amount_in_production": "",
          "total_amount_in_view": "",
          "total_amount_on_board": "",
          "total_hours_in_production": "",
          "total_hours_in_view": "",
          "total_hours_on_board": "",
          "total_jobs_in_view": "Vehículos en vista",
          "total_jobs_on_board": "Vehículos en tablero",
          "total_lab_in_production": "",
          "total_lab_in_view": "",
          "total_lab_on_board": "",
          "total_lar_in_production": "",
          "total_lar_in_view": "",
          "total_lar_on_board": ""
        },
        "statistics_title": ""
      },
      "statistics": {
        "currency_symbol": "",
        "hours": "",
        "jobs": "",
        "jobs_in_production": "Vehículos en producción",
        "tasks": "",
        "tasks_in_production": "",
        "tasks_in_view": "",
        "tasks_on_board": "",
        "total_amount_in_production": "",
        "total_amount_in_view": "",
        "total_amount_on_board": "",
        "total_hours_in_production": "",
        "total_hours_in_view": "",
        "total_hours_on_board": "",
        "total_jobs_in_view": "Vehículos en vista",
        "total_jobs_on_board": "Vehículos en tablero",
        "total_lab_in_production": "",
        "total_lab_in_view": "",
        "total_lab_on_board": "",
        "total_lar_in_production": "",
        "total_lar_in_view": "",
        "total_lar_on_board": "",
        "vehicles": "Vehículos"
      },
      "successes": {
        "removed": ""
      }
    },
    "profile": {
      "errors": {
        "state": "Error al leer el estado de la página.  Porfavor refresca."
      },
      "labels": {
        "activeshop": ""
      },
      "successes": {
        "updated": ""
      }
    },
    "reportcenter": {
      "actions": {
        "generate": ""
      },
      "labels": {
        "advanced_filters": "",
        "advanced_filters_false": "",
        "advanced_filters_filter_field": "",
        "advanced_filters_filter_operator": "",
        "advanced_filters_filter_value": "",
        "advanced_filters_filters": "",
        "advanced_filters_hide": "",
        "advanced_filters_show": "",
        "advanced_filters_sorter_direction": "",
        "advanced_filters_sorter_field": "",
        "advanced_filters_sorters": "",
        "advanced_filters_true": "",
        "dates": "",
        "employee": "",
        "filterson": "",
        "generateasemail": "",
        "groups": {
          "customers": "",
          "jobs": "",
          "payroll": "",
          "purchases": "",
          "sales": ""
        },
        "key": "",
        "objects": {
          "appointments": "",
          "bills": "",
          "csi": "",
          "exportlogs": "",
          "jobs": "",
          "parts_orders": "",
          "payments": "",
          "scoreboard": "",
          "tasks": "",
          "timetickets": ""
        },
        "vendor": ""
      },
      "production_search": {
        "action_csr": "CSR",
        "action_technician": "Técnico",
        "action_writer": "Escritor",
        "hints": {
          "close": "cerrar",
          "navigate": "navegar",
          "select": "seleccionar"
        },
        "noresults": "No hay resultados para \"{{search}}\"",
        "placeholder": "Buscar informes, empleados, categorías, estados...",
        "scope_all": "Todo",
        "scope_category": "Categoría",
        "scope_employees": "Empleados",
        "scope_reports": "Informes",
        "scope_status": "Estado",
        "section_employees": "Empleados",
        "section_reports": "Informes"
      },
      "templates": {
        "adp_payroll_flat": "",
        "adp_payroll_straight": "",
        "anticipated_revenue": "",
        "ar_aging": "",
        "attendance_detail": "",
        "attendance_employee": "",
        "attendance_summary": "",
        "committed_timetickets": "",
        "committed_timetickets_employee": "",
        "committed_timetickets_summary": "",
        "credits_not_received_date": "",
        "credits_not_received_date_vendorid": "",
        "csi": "",
        "customer_list": "",
        "customer_list_excel": "",
        "cycle_time_analysis": "",
        "estimates_written_converted": "",
        "estimator_detail": "",
        "estimator_summary": "",
        "export_payables": "",
        "export_payments": "",
        "export_receivables": "",
        "exported_gsr_by_ro": "",
        "exported_gsr_by_ro_labor": "",
        "gsr_by_atp": "",
        "gsr_by_ats": "",
        "gsr_by_category": "",
        "gsr_by_csr": "",
        "gsr_by_delivery_date": "",
        "gsr_by_estimator": "",
        "gsr_by_exported_date": "",
        "gsr_by_ins_co": "",
        "gsr_by_make": "",
        "gsr_by_referral": "",
        "gsr_by_ro": "",
        "gsr_labor_only": "",
        "hours_sold_detail_closed": "",
        "hours_sold_detail_closed_csr": "",
        "hours_sold_detail_closed_estimator": "",
        "hours_sold_detail_closed_ins_co": "",
        "hours_sold_detail_closed_status": "",
        "hours_sold_detail_open": "",
        "hours_sold_detail_open_csr": "",
        "hours_sold_detail_open_estimator": "",
        "hours_sold_detail_open_ins_co": "",
        "hours_sold_detail_open_status": "",
        "hours_sold_summary_closed": "",
        "hours_sold_summary_closed_csr": "",
        "hours_sold_summary_closed_estimator": "",
        "hours_sold_summary_closed_ins_co": "",
        "hours_sold_summary_closed_status": "",
        "hours_sold_summary_open": "",
        "hours_sold_summary_open_csr": "",
        "hours_sold_summary_open_estimator": "",
        "hours_sold_summary_open_ins_co": "",
        "hours_sold_summary_open_status": "",
        "job_costing_ro_csr": "",
        "job_costing_ro_date_detail": "",
        "job_costing_ro_date_summary": "",
        "job_costing_ro_estimator": "",
        "job_costing_ro_ins_co": "",
        "job_lifecycle_date_detail": "",
        "job_lifecycle_date_summary": "",
        "jobs_completed_not_invoiced": "",
        "jobs_invoiced_not_exported": "",
        "jobs_reconcile": "",
        "jobs_scheduled_completion": "",
        "lag_time": "",
        "load_level": "",
        "lost_sales": "",
        "open_orders": "",
        "open_orders_csr": "",
        "open_orders_estimator": "",
        "open_orders_excel": "",
        "open_orders_ins_co": "",
        "open_orders_referral": "",
        "open_orders_specific_csr": "",
        "open_orders_status": "",
        "parts_backorder": "",
        "parts_not_recieved": "",
        "parts_not_recieved_vendor": "",
        "parts_received_not_scheduled": "",
        "payments_by_date": "",
        "payments_by_date_excel": "",
        "payments_by_date_payment": "",
        "payments_by_date_type": "",
        "production_by_category": "Producción por categoría",
        "production_by_category_one": "Producción filtrada por categoría",
        "production_by_csr": "Producción por CSR",
        "production_by_csr_one": "Producción filtrada por CSR",
        "production_by_writer": "Producción por escritor",
        "production_by_writer_one": "Producción filtrada por escritor",
        "production_by_last_name": "Producción por apellido",
        "production_by_repair_status": "Producción por estado",
        "production_by_repair_status_one": "Producción filtrada por estado",
        "production_by_ro": "Producción por OT",
        "production_by_target_date": "Producción por fecha de finalización programada",
        "production_by_technician": "Producción por técnico",
        "production_by_technician_one": "Producción filtrada por técnico",
        "production_not_production_status": "",
        "production_over_time": "",
        "psr_by_make": "",
        "purchase_return_ratio_excel": "",
        "purchase_return_ratio_grouped_by_vendor_detail": "",
        "purchase_return_ratio_grouped_by_vendor_summary": "",
        "purchases_by_cost_center_detail": "",
        "purchases_by_cost_center_summary": "",
        "purchases_by_date_excel": "",
        "purchases_by_date_range_detail": "",
        "purchases_by_date_range_summary": "",
        "purchases_by_ro_detail_date": "",
        "purchases_by_ro_summary_date": "",
        "purchases_by_vendor_detailed_date_range": "",
        "purchases_by_vendor_summary_date_range": "",
        "purchases_grouped_by_vendor_detailed": "",
        "purchases_grouped_by_vendor_summary": "",
        "returns_grouped_by_vendor_detailed": "",
        "returns_grouped_by_vendor_summary": "",
        "schedule": "",
        "scheduled_parts_list": "",
        "scoreboard_detail": "",
        "scoreboard_summary": "",
        "supplement_ratio_ins_co": "",
        "tasks_date": "",
        "tasks_date_employee": "",
        "thank_you_date": "",
        "timetickets": "",
        "timetickets_employee": "",
        "timetickets_summary": "",
        "total_loss_jobs": "",
        "unclaimed_hrs": "",
        "void_ros": "",
        "work_in_progress_committed_labour": "",
        "work_in_progress_jobs": "",
        "work_in_progress_labour": "",
        "work_in_progress_labour_summary": "",
        "work_in_progress_payables": "",
        "work_in_progress_payables_summary": ""
      }
    },
    "schedule": {
      "labels": {
        "atssummary": "",
        "employeevacation": "",
        "estimators": "",
        "ins_co_nm_filter": "",
        "intake": "",
        "manual": "",
        "manualevent": ""
      }
    },
    "scoreboard": {
      "actions": {
        "edit": ""
      },
      "errors": {
        "adding": "",
        "removing": "",
        "updating": ""
      },
      "fields": {
        "bodyhrs": "",
        "date": "",
        "painthrs": ""
      },
      "labels": {
        "allemployeetimetickets": "",
        "asoftodaytarget": "",
        "body": "",
        "bodyabbrev": "",
        "bodycharttitle": "",
        "calendarperiod": "",
        "combinedcharttitle": "",
        "dailyactual": "",
        "dailytarget": "",
        "efficiencyoverperiod": "",
        "entries": "",
        "jobs": "",
        "jobscompletednotinvoiced": "",
        "lastmonth": "",
        "lastweek": "",
        "monthlytarget": "",
        "priorweek": "",
        "productivestatistics": "",
        "productivetimeticketsoverdate": "",
        "refinish": "",
        "refinishabbrev": "",
        "refinishcharttitle": "",
        "targets": "",
        "thismonth": "",
        "thisweek": "",
        "timetickets": "",
        "timeticketsemployee": "",
        "todateactual": "",
        "total": "",
        "totalhrs": "",
        "totaloverperiod": "",
        "weeklyactual": "",
        "weeklytarget": "",
        "workingdays": ""
      },
      "successes": {
        "added": "",
        "removed": "",
        "updated": ""
      }
    },
    "settings": {
      "title": ""
    },
    "tasks": {
      "actions": {
        "edit": "",
        "new": "",
        "view": ""
      },
      "buttons": {
        "allTasks": "",
        "complete": "",
        "create": "",
        "delete": "",
        "edit": "",
        "myTasks": "",
        "refresh": ""
      },
      "date_presets": {
        "completion": "",
        "day": "",
        "days": "",
        "delivery": "",
        "next_week": "",
        "one_month": "",
        "three_months": "",
        "three_weeks": "",
        "today": "",
        "tomorrow": "",
        "two_weeks": ""
      },
      "errors": {
        "load_failure": ""
      },
      "failures": {
        "completed": "",
        "created": "",
        "deleted": "",
        "updated": ""
      },
      "fields": {
        "actions": "",
        "assigned_to": "",
        "bill": "",
        "billid": "",
        "completed": "",
        "created_at": "",
        "created_by": "",
        "description": "",
        "due_date": "",
        "job": {
          "ro_number": ""
        },
        "jobid": "",
        "jobline": "",
        "joblineid": "",
        "parts_order": "",
        "partsorderid": "",
        "priorities": {
          "high": "",
          "low": "",
          "medium": ""
        },
        "priority": "",
        "related_items": "",
        "remind_at": "",
        "title": ""
      },
      "labels": {
        "due_today": "",
        "go_to_job": "",
        "my_tasks_center": "",
        "no_due_date": "",
        "no_tasks": "",
        "overdue": "",
        "ro-number": "",
        "upcoming": ""
      },
      "placeholders": {
        "assigned_to": "",
        "billid": "",
        "description": "",
        "jobid": "",
        "joblineid": "",
        "partsorderid": ""
      },
      "successes": {
        "completed": "",
        "created": "",
        "deleted": "",
        "updated": ""
      },
      "titles": {
        "all_tasks": "",
        "completed": "",
        "deleted": "",
        "job_tasks": "",
        "mine": "",
        "my_tasks": ""
      },
      "validation": {
        "due_at_error_message": "",
        "remind_at_error_message": ""
      }
    },
    "tech": {
      "fields": {
        "employeeid": "",
        "pin": ""
      },
      "inactivity": {
        "logout_now": "Cerrar sesión ahora",
        "message": "La sesión se cerrará en {{seconds}} segundos por inactividad.",
        "stay_signed_in": "Mantener la sesión iniciada",
        "title": "¿Sigue ahí?"
      },
      "labels": {
        "loggedin": "",
        "notloggedin": ""
      }
    },
    "templates": {
      "errors": {
        "updating": ""
      },
      "successes": {
        "updated": ""
      }
    },
    "timetickets": {
      "actions": {
        "claimtasks": "",
        "clockin": "",
        "clockout": "",
        "commit": "",
        "commitone": "",
        "enter": "",
        "payall": "",
        "printemployee": "",
        "uncommit": ""
      },
      "errors": {
        "clockingin": "",
        "clockingout": "",
        "creating": "",
        "deleting": "",
        "noemployeeforuser": "",
        "noemployeeforuser_sub": "",
        "notickets": "",
        "payall": "",
        "shiftalreadyclockedon": ""
      },
      "fields": {
        "actualhrs": "",
        "amount": "",
        "ciecacode": "",
        "clockhours": "",
        "clockoff": "",
        "clockon": "",
        "committed": "",
        "committed_at": "",
        "cost_center": "",
        "created_by": "",
        "date": "",
        "efficiency": "",
        "employee": "",
        "employee_team": "",
        "flat_rate": "",
        "memo": "",
        "not_committed": "",
        "pay": "",
        "payout_method": "",
        "productivehrs": "",
        "rate": "",
        "ro_number": "",
        "task_name": ""
      },
      "labels": {
        "alreadyclockedon": "",
        "ambreak": "",
        "amshift": "",
        "claimtaskpreview": "",
        "clockhours": "",
        "clockintojob": "",
        "deleteconfirm": "",
        "edit": "",
        "efficiency": "",
        "flat_rate": "",
        "jobhours": "",
        "lunch": "",
        "new": "",
        "payout_methods": {
          "commission": "",
          "hourly": ""
        },
        "payrollclaimedtasks": "",
        "pmbreak": "",
        "pmshift": "",
        "selectTicketDate": "",
        "shift": "",
        "shiftalreadyclockedon": "",
        "straight_time": "",
        "task": "",
        "timetickets": "",
        "unassigned": "",
        "zeroactualnegativeprod": ""
      },
      "successes": {
        "clockedin": "",
        "clockedout": "",
        "committed": "",
        "created": "",
        "deleted": "",
        "payall": ""
      },
      "validation": {
        "clockoffmustbeafterclockon": "",
        "clockoffwithoutclockon": "",
        "hoursenteredmorethanavailable": "",
        "unassignedlines": ""
      }
    },
    "titles": {
      "accounting-payables": "",
      "accounting-payments": "",
      "accounting-receivables": "",
      "all_tasks": "",
      "app": "",
      "bc": {
        "accounting-payables": "",
        "accounting-payments": "",
        "accounting-receivables": "",
        "all_tasks": "",
        "availablejobs": "",
        "bills-list": "",
        "contracts": "",
        "contracts-create": "",
        "contracts-detail": "",
        "courtesycars": "",
        "courtesycars-detail": "",
        "courtesycars-new": "",
        "dashboard": "",
        "dms": "",
        "export-logs": "",
        "feature-request": "",
        "inventory": "",
        "jobs": "",
        "jobs-active": "",
        "jobs-admin": "",
        "jobs-all": "",
        "jobs-checklist": "",
        "jobs-close": "",
        "jobs-deliver": "",
        "jobs-detail": "",
        "jobs-intake": "",
        "jobs-new": "",
        "jobs-ready": "",
        "my_tasks": "",
        "owner-detail": "",
        "owners": "",
        "parts": "",
        "parts-queue": "",
        "parts_settings": "",
        "payments-all": "",
        "phonebook": "",
        "productionboard": "",
        "productionlist": "",
        "profile": "",
        "schedule": "",
        "scoreboard": "",
        "shop": "",
        "shop-csi": "",
        "shop-templates": "",
        "shop-vendors": "",
        "simplified-parts-jobs": "",
        "tasks": "",
        "temporarydocs": "",
        "timetickets": "",
        "ttapprovals": "",
        "vehicle-details": "",
        "vehicles": ""
      },
      "bills-list": "",
      "contracts": "",
      "contracts-create": "",
      "contracts-detail": "",
      "courtesycars": "",
      "courtesycars-create": "",
      "courtesycars-detail": "",
      "dashboard": "",
      "dms": "",
      "export-logs": "",
      "feature-request": "",
      "imexonline": "",
      "inventory": "",
      "jobs": "Todos los trabajos | {{app}}",
      "jobs-admin": "",
      "jobs-all": "",
      "jobs-checklist": "",
      "jobs-close": "",
      "jobs-create": "",
      "jobs-deliver": "",
      "jobs-intake": "",
      "jobsavailable": "Empleos disponibles | {{app}}",
      "jobsdetail": "Trabajo {{ro_number}} | {{app}}",
      "jobsdocuments": "Documentos de trabajo {{ro_number}} | {{app}}",
      "manageroot": "Casa | {{app}}",
      "my_tasks": "",
      "owners": "Todos los propietarios | {{app}}",
      "owners-detail": "",
      "parts": "",
      "parts-queue": "",
      "parts_settings": "",
      "payments-all": "",
      "phonebook": "",
      "productionboard": "",
      "productionlist": "",
      "profile": "Mi perfil | {{app}}",
      "readyjobs": "",
      "resetpassword": "",
      "resetpasswordvalidate": "",
      "romeonline": "",
      "schedule": "Horario | {{app}}",
      "scoreboard": "",
      "shop": "Mi tienda | {{app}}",
      "shop-csi": "",
      "shop-templates": "",
      "shop_vendors": "Vendedores | {{app}}",
      "simplified-parts-jobs": "",
      "tasks": "",
      "techconsole": "{{app}}",
      "techjobclock": "{{app}}",
      "techjoblookup": "{{app}}",
      "techshiftclock": "{{app}}",
      "temporarydocs": "",
      "timetickets": "",
      "ttapprovals": "",
      "vehicledetail": "Detalles del vehículo {{vehicle}} | {{app}}",
      "vehicles": "Todos los vehiculos | {{app}}"
    },
    "trello": {
      "labels": {
        "add_card": "",
        "add_lane": "",
        "cancel": "",
        "delete_lane": "",
        "description": "",
        "label": "",
        "lane_actions": "",
        "title": ""
      }
    },
    "tt_approvals": {
      "actions": {
        "approveselected": ""
      },
      "labels": {
        "approval_queue_in_use": "",
        "calculate": ""
      }
    },
    "upsell": {
      "cta": {
        "learnmore": ""
      },
      "messages": {
        "accounting": {
          "payables": {
            "subtitle": "",
            "title": ""
          },
          "payments": {
            "subtitle": "",
            "title": ""
          },
          "receivables": {
            "subtitle": "",
            "title": ""
          }
        },
        "audit": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "bills": {
          "autoreconcile": {
            "subtitle": "",
            "title": ""
          },
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "checklist": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "courtesycars": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "csi": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "dashboard": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "lifecycle": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "media": {
          "general": {
            "subtitle": "",
            "title": ""
          },
          "mobile": {
            "subtitle": "",
            "title": ""
          }
        },
        "payments": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "scoreboard": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "smartscheduling": {
          "datepicker": {
            "subtitle": "",
            "title": ""
          },
          "general": {
            "subtitle": "",
            "title": ""
          },
          "hrsdelta": {
            "subtitle": "",
            "title": ""
          }
        },
        "techconsole": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "timetickets": {
          "allocations": {
            "subtitle": "",
            "title": ""
          },
          "general": {
            "subtitle": "",
            "title": ""
          }
        },
        "visualboard": {
          "general": {
            "subtitle": "",
            "title": ""
          }
        }
      }
    },
    "user": {
      "actions": {
        "changepassword": "",
        "dark_theme": "",
        "light_theme": "",
        "signout": "desconectar",
        "updateprofile": "Actualización del perfil"
      },
      "errors": {
        "updating": ""
      },
      "fields": {
        "authlevel": "",
        "displayname": "Nombre para mostrar",
        "email": "",
        "photourl": "URL de avatar"
      },
      "labels": {
        "actions": "",
        "changepassword": "",
        "notification_sound_disabled": "",
        "notification_sound_enabled": "",
        "notification_sound_help": "",
        "notification_sound_off": "",
        "notification_sound_on": "",
        "play_sound_for_new_messages": "",
        "profileinfo": "",
        "user_settings": ""
      },
      "successess": {
        "passwordchanged": ""
      }
    },
    "users": {
      "errors": {
        "signinerror": {
          "auth/invalid-email": "",
          "auth/user-disabled": "",
          "auth/user-not-found": "",
          "auth/wrong-password": ""
        }
      }
    },
    "vehicles": {
      "errors": {
        "deleting": "",
        "noaccess": "El vehículo no existe o usted no tiene acceso a él.",
        "selectexistingornew": "",
        "validation": "Asegúrese de que todos los campos se ingresen correctamente.",
        "validationtitle": "Error de validacion"
      },
      "fields": {
        "description": "Descripcion del vehiculo",
        "notes": "",
        "plate_no": "Placa",
        "plate_st": "Jurisdicción de placas",
        "trim_color": "Recortar color",
        "v_bstyle": "Tipo de cuerpo",
        "v_color": "Color",
        "v_cond": "condición",
        "v_engine": "Motor",
        "v_make_desc": "Hacer",
        "v_makecode": "Hacer código",
        "v_mldgcode": "Código de moldeo",
        "v_model_desc": "Modelo",
        "v_model_yr": "año",
        "v_options": "Opciones",
        "v_paint_codes": "Códigos de pintura",
        "v_prod_dt": "Fecha de producción",
        "v_stage": "Escenario",
        "v_tone": "Tono",
        "v_trimcode": "Código de recorte",
        "v_type": "Tipo",
        "v_vin": "V.I.N."
      },
      "forms": {
        "detail": "",
        "misc": "",
        "registration": ""
      },
      "labels": {
        "deleteconfirm": "",
        "fromvehicle": "",
        "novehinfo": "",
        "relatedjobs": "",
        "updatevehicle": ""
      },
      "successes": {
        "delete": "",
        "save": "Vehículo guardado con éxito."
      }
    },
    "vendors": {
      "actions": {
        "addtophonebook": "Add to Phonebook",
        "new": "Nuevo vendedor",
        "newpreferredmake": "New Preferred Make"
      },
      "errors": {
        "deleting": "Se encontró un error al eliminar el proveedor.",
        "saving": "Se encontró un error al guardar el proveedor."
      },
      "fields": {
        "active": "Active",
        "am": "",
        "city": "ciudad",
        "cost_center": "Centro de costos",
        "country": "País",
        "discount": "Discount",
        "display_name": "Nombre para mostrar",
        "dmsid": "DMS ID",
        "due_date": "Payment Due Date",
        "email": "Email de contacto",
        "favorite": "¿Favorito?",
        "lkq": "",
        "make": "Make",
        "name": "Nombre del vendedor",
        "oem": "",
        "phone": "Phone",
        "prompt_discount": "Descuento pronto",
        "state": "Provincia del estado",
        "street1": "calle",
        "street2": "Dirección 2",
        "tags": "Tags",
        "taxid": "Identificación del impuesto",
        "terms": "Términos de pago",
        "zip": "código postal"
      },
      "labels": {
        "inputprefixes": {
          "days": "# Of Days",
          "discount": "%"
        },
        "noneselected": "Ningún vendedor está seleccionado.",
        "preferredmakes": "Preferred Makes for Vendor",
        "search": "Escriba el nombre de un proveedor",
        "sections": {
          "address": "Address",
          "billing": "Billing Defaults",
          "contact": "Contact",
          "location": "Location",
          "tags": "Tags",
          "vendor": "Vendor Details"
        },
        "vendor": "Vendor"
      },
      "successes": {
        "deleted": "Proveedor eliminado correctamente.",
        "saved": "Proveedor guardado con éxito."
      },
      "validation": {
        "unique_vendor_name": ""
      }
    }
  }
}
